// Trust Registration Form JavaScript with Wizard functionality

// Helper function to convert DD/MM/YYYY to ISO format
function convertAustralianDateToISO(dateStr) {
    if (!dateStr) return null;
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;
    
    const day = parts[0].padStart(2, '0');
    const month = parts[1].padStart(2, '0');
    const year = parts[2];
    
    // Validate the date
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() != year || date.getMonth() != month - 1 || date.getDate() != day) {
        return null;
    }
    
    return date.toISOString();
}

let currentStep = 1;
const totalSteps = 4;

// Wizard navigation functions
function changeStep(direction) {
    const newStep = currentStep + direction;
    
    if (newStep >= 1 && newStep <= totalSteps) {
        // Hide current step
        const currentStepElement = document.getElementById(`step-${currentStep}`);
        const currentNavBtn = document.querySelector(`.step-nav-btn[data-step="${currentStep}"]`);
        
        if (currentStepElement) {
            currentStepElement.classList.remove('active');
        }
        if (currentNavBtn) {
            currentNavBtn.classList.remove('active');
        }
        
        // Show new step
        currentStep = newStep;
        const newStepElement = document.getElementById(`step-${currentStep}`);
        const newNavBtn = document.querySelector(`.step-nav-btn[data-step="${currentStep}"]`);
        
        if (newStepElement) {
            newStepElement.classList.add('active');
        }
        if (newNavBtn) {
            newNavBtn.classList.add('active');
        }
        
        updateProgress();
        updateNavigationButtons();
        
        // Scroll to top
        window.scrollTo(0, 0);
    }
}

function handleNextStep() {
    // Validate current step before proceeding
    if (validateCurrentStep()) {
        if (currentStep === 3) {
            // When moving to step 4 (review), populate the review content
            populateReviewContent();
        }
        changeStep(1);
    }
}

function validateCurrentStep() {
    const currentStepElement = document.getElementById(`step-${currentStep}`);
    const requiredFields = currentStepElement.querySelectorAll('[required]');
    let isValid = true;
    
    requiredFields.forEach(field => {
        // Only validate fields that are visible (not in hidden sections)
        const isVisible = isFieldVisible(field);
        
        if (isVisible) {
            if (!field.value.trim()) {
                field.classList.add('border-red-500');
                isValid = false;
            } else {
                field.classList.remove('border-red-500');
            }
        } else {
            // Remove validation styling from hidden fields
            field.classList.remove('border-red-500');
        }
    });
    
    if (!isValid) {
        alert('Please fill in all required fields before proceeding.');
    }
    
    return isValid;
}

// Helper function to check if a field is visible
function isFieldVisible(field) {
    let element = field;
    
    // Traverse up the DOM tree to check if any parent has 'hidden' class
    while (element && element !== document.body) {
        if (element.classList && element.classList.contains('hidden')) {
            return false;
        }
        // Also check for display: none style
        const computedStyle = window.getComputedStyle(element);
        if (computedStyle.display === 'none') {
            return false;
        }
        element = element.parentElement;
    }
    
    return true;
}

function updateProgress() {
    const percentage = (currentStep / totalSteps) * 100;
    document.getElementById('progressBar').style.width = `${percentage}%`;
    document.getElementById('progressText').textContent = `Step ${currentStep} of ${totalSteps}`;
}

function updateNavigationButtons() {
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');
    
    prevBtn.disabled = currentStep === 1;
    
    if (currentStep === totalSteps) {
        nextBtn.style.display = 'none';
    } else {
        nextBtn.style.display = 'block';
        nextBtn.textContent = 'Next';
    }
}

function populateReviewContent() {
    const reviewContent = document.getElementById('reviewContent');
    let content = '<div class="space-y-6">';
    
    // Step 1: Trustee Information
    content += '<div class="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">';
    content += '<h3 class="text-lg font-semibold text-gold-600 mb-4 border-b border-gray-100 pb-2">Step 1: Trustee Information</h3>';
    
    const trusteeType = document.getElementById('trusteeType');
    if (trusteeType && trusteeType.value) {
        content += `<div class="mb-4"><p class="text-sm text-gray-600">Trustee Type</p><p class="font-medium">${trusteeType.value === 'individual' ? 'Individual Trustee' : 'Company (Corporate) Trustee'}</p></div>`;
        
        if (trusteeType.value === 'individual') {
            // Individual Trustee Details
            const individualFields = [
                {id: 'individualFirstName', label: 'First Name'},
                {id: 'individualMiddleName', label: 'Middle Name'},
                {id: 'individualLastName', label: 'Last Name'},
                {id: 'individualEmail', label: 'Email'},
                {id: 'individualTelephone', label: 'Telephone'},
                {id: 'individualDateOfBirth', label: 'Date of Birth'},
                {id: 'individualCityOfBirth', label: 'City of Birth'},
                {id: 'individualCountryOfBirth', label: 'Country of Birth'},
                {id: 'individualTFN', label: 'Tax File Number'},
                {id: 'individualDIN', label: 'Director Identification Number'}
            ];
            
            content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">';
            individualFields.forEach(field => {
                const element = document.getElementById(field.id);
                if (element && element.value.trim()) {
                    content += `<div><p class="text-sm text-gray-600">${field.label}</p><p class="font-medium">${element.value}</p></div>`;
                }
            });
            content += '</div>';
            
        } else if (trusteeType.value === 'corporate') {
            // Corporate Trustee Details
            const isExisting = document.getElementById('isExistingCompany');
            if (isExisting && isExisting.value) {
                content += `<div class="mb-4"><p class="text-sm text-gray-600">Company Type</p><p class="font-medium">${isExisting.value === 'yes' ? 'Existing Company' : 'New Company'}</p></div>`;
                
                if (isExisting.value === 'yes') {
                    // Existing Company Details
                    const existingACN = document.getElementById('existingCompanyACN');
                    const existingName = document.getElementById('existingCompanyName');
                    
                    content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">';
                    if (existingACN && existingACN.value.trim()) {
                        content += `<div><p class="text-sm text-gray-600">Company ACN</p><p class="font-medium">${existingACN.value}</p></div>`;
                    }
                    if (existingName && existingName.value.trim()) {
                        content += `<div><p class="text-sm text-gray-600">Company Name</p><p class="font-medium">${existingName.value}</p></div>`;
                    }
                    content += '</div>';
                    
                } else if (isExisting.value === 'no') {
                    // New Company Details
                    const proposedName = document.getElementById('proposedCompanyName');
                    const numberOfDirectors = document.getElementById('numberOfDirectors');
                    
                    content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">';
                    if (proposedName && proposedName.value.trim()) {
                        content += `<div><p class="text-sm text-gray-600">Proposed Company Name</p><p class="font-medium">${proposedName.value}</p></div>`;
                    }
                    if (numberOfDirectors && numberOfDirectors.value.trim()) {
                        content += `<div><p class="text-sm text-gray-600">Number of Directors</p><p class="font-medium">${numberOfDirectors.value}</p></div>`;
                    }
                    content += '</div>';
                    
                    // Directors Information
                    const directorCount = numberOfDirectors ? parseInt(numberOfDirectors.value) : 0;
                    if (directorCount > 0) {
                        content += '<div class="mt-6"><h4 class="font-medium text-gray-700 mb-3">Directors Information</h4>';
                        for (let i = 1; i <= directorCount; i++) {
                            const directorName = document.getElementById(`director${i}FirstName`);
                            const directorLastName = document.getElementById(`director${i}LastName`);
                            if (directorName && directorName.value.trim()) {
                                content += `<div class="mb-4 p-4 bg-gray-50 rounded border"><h5 class="font-medium mb-2">Director ${i}: ${directorName.value} ${directorLastName ? directorLastName.value : ''}</h5>`;
                                
                                const directorFields = [
                                    {id: `director${i}Email`, label: 'Email'},
                                    {id: `director${i}Telephone`, label: 'Telephone'},
                                    {id: `director${i}DateOfBirth`, label: 'Date of Birth'},
                                    {id: `director${i}IsShareHolder`, label: 'Shareholder Status'}
                                ];
                                
                                content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">';
                                directorFields.forEach(field => {
                                    const element = document.getElementById(field.id);
                                    if (element && element.value.trim()) {
                                        let value = element.value;
                                        if (field.id.includes('IsShareHolder')) {
                                            value = value === 'yes' ? 'Will hold shares' : 'Will not hold shares';
                                        }
                                        content += `<div><span class="text-gray-600">${field.label}:</span> <span class="font-medium">${value}</span></div>`;
                                    }
                                });
                                content += '</div></div>';
                            }
                        }
                        content += '</div>';
                    }
                }
            }
        }
    }
    content += '</div>';
    
    // Step 2: Trust Registration Details
    content += '<div class="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">';
    content += '<h3 class="text-lg font-semibold text-gold-600 mb-4 border-b border-gray-100 pb-2">Step 2: Trust Registration Details</h3>';
    
    const trustDetails = [
        {id: 'trustName', label: 'Trust Name'},
        {id: 'trustIndustry', label: 'Industry'},
        {id: 'trustBusinessActivity', label: 'Business Activity'}
    ];
    
    let hasDetails = false;
    content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-4">';
    trustDetails.forEach(field => {
        const element = document.getElementById(field.id);
        if (element && element.value.trim()) {
            hasDetails = true;
            content += `<div><p class="text-sm text-gray-600">${field.label}</p><p class="font-medium">${element.value}</p></div>`;
        }
    });
    content += '</div>';
    
    // Registrations
    const abnReg = document.getElementById('abnRegistration');
    const gstReg = document.getElementById('gstRegistration');
    const paygReg = document.getElementById('paygWithholdingRegistration');
    
    if ((abnReg && abnReg.checked) || (gstReg && gstReg.checked) || (paygReg && paygReg.checked)) {
        content += '<div class="mt-4"><h4 class="font-medium text-gray-700 mb-2">Required Registrations</h4><ul class="space-y-1">';
        if (abnReg && abnReg.checked) content += '<li class="flex items-center"><i class="fas fa-check text-green-600 mr-2"></i>ABN registration required</li>';
        if (gstReg && gstReg.checked) content += '<li class="flex items-center"><i class="fas fa-check text-green-600 mr-2"></i>GST Registration required</li>';
        if (paygReg && paygReg.checked) content += '<li class="flex items-center"><i class="fas fa-check text-green-600 mr-2"></i>PAYG Withholding registration required</li>';
        content += '</ul></div>';
    }
    
    if (!hasDetails && (!abnReg || !abnReg.checked) && (!gstReg || !gstReg.checked) && (!paygReg || !paygReg.checked)) {
        content += '<p class="text-gray-500 italic">No details entered yet</p>';
    }
    
    content += '</div>';
    
    // Step 3: Business Structure
    content += '<div class="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">';
    content += '<h3 class="text-lg font-semibold text-gold-600 mb-4 border-b border-gray-100 pb-2">Step 3: Business Structure</h3>';
    
    const trustTypeField = document.getElementById('trustType');
    if (trustTypeField && trustTypeField.value) {
        content += `<div class="mb-4"><p class="text-sm text-gray-600">Trust Type</p><p class="font-medium">${trustTypeField.value}</p></div>`;
        
        // Show beneficiaries/unit holders based on trust type
        if (trustTypeField.value === 'Discretionary Trust') {
            const beneficiaryCount = document.getElementById('discretionaryBeneficiaries');
            if (beneficiaryCount && beneficiaryCount.value) {
                content += `<div class="mb-4"><p class="text-sm text-gray-600">Number of Beneficiaries</p><p class="font-medium">${beneficiaryCount.value}</p></div>`;
                content += '<div class="mt-4"><h4 class="font-medium text-gray-700 mb-3">Beneficiaries</h4>';
                
                for (let i = 1; i <= parseInt(beneficiaryCount.value); i++) {
                    const firstName = document.getElementById(`discretionaryBeneficiaryFirstName${i}`);
                    const lastName = document.getElementById(`discretionaryBeneficiaryLastName${i}`);
                    if (firstName && firstName.value.trim()) {
                        content += `<div class="mb-3 p-3 bg-gray-50 rounded border"><h5 class="font-medium">Beneficiary ${i}: ${firstName.value} ${lastName ? lastName.value : ''}</h5>`;
                        
                        const dob = document.getElementById(`discretionaryBeneficiaryDOB${i}`);
                        const tfn = document.getElementById(`discretionaryBeneficiaryTaxFileNumber${i}`);
                        
                        content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm mt-2">';
                        if (dob && dob.value) content += `<div><span class="text-gray-600">Date of Birth:</span> <span class="font-medium">${dob.value}</span></div>`;
                        if (tfn && tfn.value) content += `<div><span class="text-gray-600">TFN:</span> <span class="font-medium">${tfn.value}</span></div>`;
                        content += '</div></div>';
                    }
                }
                content += '</div>';
            }
        } else if (trustTypeField.value === 'Unit Trusts') {
            const unitHolderCount = document.getElementById('unitHolders');
            if (unitHolderCount && unitHolderCount.value) {
                content += `<div class="mb-4"><p class="text-sm text-gray-600">Number of Unit Holders</p><p class="font-medium">${unitHolderCount.value}</p></div>`;
                content += '<div class="mt-4"><h4 class="font-medium text-gray-700 mb-3">Unit Holders</h4>';
                
                for (let i = 1; i <= parseInt(unitHolderCount.value); i++) {
                    const holderType = document.getElementById(`unitHolderType${i}`);
                    if (holderType && holderType.value) {
                        content += `<div class="mb-3 p-3 bg-gray-50 rounded border"><h5 class="font-medium">Unit Holder ${i} (${holderType.value})</h5>`;
                        
                        if (holderType.value === 'individual') {
                            const firstName = document.getElementById(`unitHolderFirstName${i}`);
                            const lastName = document.getElementById(`unitHolderLastName${i}`);
                            if (firstName && firstName.value.trim()) {
                                content += `<p class="text-sm"><span class="text-gray-600">Name:</span> <span class="font-medium">${firstName.value} ${lastName ? lastName.value : ''}</span></p>`;
                            }
                        } else if (holderType.value === 'company') {
                            const companyName = document.getElementById(`unitHolderCompanyName${i}`);
                            const abn = document.getElementById(`unitHolderABN${i}`);
                            if (companyName && companyName.value.trim()) {
                                content += `<p class="text-sm"><span class="text-gray-600">Company Name:</span> <span class="font-medium">${companyName.value}</span></p>`;
                            }
                            if (abn && abn.value.trim()) {
                                content += `<p class="text-sm"><span class="text-gray-600">ABN:</span> <span class="font-medium">${abn.value}</span></p>`;
                            }
                        }
                        
                        const units = document.getElementById(`unitHolderUnits${i}`);
                        if (units && units.value) {
                            content += `<p class="text-sm"><span class="text-gray-600">Number of Units:</span> <span class="font-medium">${units.value}</span></p>`;
                        }
                        content += '</div>';
                    }
                }
                content += '</div>';
            }
        } else if (trustTypeField.value !== '') {
            // Other trust types with beneficiaries
            const otherBeneficiaryCount = document.getElementById('otherBeneficiaries');
            if (otherBeneficiaryCount && otherBeneficiaryCount.value) {
                content += `<div class="mb-4"><p class="text-sm text-gray-600">Number of Beneficiaries</p><p class="font-medium">${otherBeneficiaryCount.value}</p></div>`;
                content += '<div class="mt-4"><h4 class="font-medium text-gray-700 mb-3">Beneficiaries</h4>';
                
                for (let i = 1; i <= parseInt(otherBeneficiaryCount.value); i++) {
                    const firstName = document.getElementById(`otherBeneficiaryFirstName${i}`);
                    const lastName = document.getElementById(`otherBeneficiaryLastName${i}`);
                    if (firstName && firstName.value.trim()) {
                        content += `<div class="mb-3 p-3 bg-gray-50 rounded border"><h5 class="font-medium">Beneficiary ${i}: ${firstName.value} ${lastName ? lastName.value : ''}</h5>`;
                        
                        const dob = document.getElementById(`otherBeneficiaryDOB${i}`);
                        const tfn = document.getElementById(`otherBeneficiaryTaxFileNumber${i}`);
                        
                        content += '<div class="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm mt-2">';
                        if (dob && dob.value) content += `<div><span class="text-gray-600">Date of Birth:</span> <span class="font-medium">${dob.value}</span></div>`;
                        if (tfn && tfn.value) content += `<div><span class="text-gray-600">TFN:</span> <span class="font-medium">${tfn.value}</span></div>`;
                        content += '</div></div>';
                    }
                }
                content += '</div>';
            }
        }
    } else {
        content += '<p class="text-gray-500 italic">No business structure details entered yet</p>';
    }
    
    content += '</div>';
    
    // Step 4: Declarations Summary
    content += '<div class="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">';
    content += '<h3 class="text-lg font-semibold text-gold-600 mb-4 border-b border-gray-100 pb-2">Declarations and Nominations</h3>';
    
    const accountantNomination = document.getElementById('accountantNomination');
    const asicAgent = document.getElementById('asicRegisteredAgent');
    const signatureName = document.getElementById('trustSignatureFullName');
    const signatureDate = document.getElementById('trustSignatureDate');
    const signatureConfirmation = document.getElementById('trustManualSignatureConfirmation');
    
    content += '<div class="space-y-3">';
    
    if (accountantNomination) {
        content += `<div><p class="text-sm text-gray-600">Accountant Nomination</p><p class="font-medium">${accountantNomination.checked ? 'Silver Peacock & Co nominated as accountants' : 'Not selected'}</p></div>`;
    }
    
    if (asicAgent && asicAgent.value) {
        content += `<div><p class="text-sm text-gray-600">ASIC Registered Agent</p><p class="font-medium">${asicAgent.value === 'yes' ? 'Silver Peacock & Co nominated as ASIC agent' : 'Not nominated'}</p></div>`;
    }
    
    if (signatureName && signatureName.value.trim()) {
        content += `<div><p class="text-sm text-gray-600">Signature Name</p><p class="font-medium">${signatureName.value}</p></div>`;
    }
    
    if (signatureDate && signatureDate.value) {
        content += `<div><p class="text-sm text-gray-600">Signature Date</p><p class="font-medium">${signatureDate.value}</p></div>`;
    }
    
    if (signatureConfirmation) {
        content += `<div><p class="text-sm text-gray-600">Signature Confirmation</p><p class="font-medium">${signatureConfirmation.checked ? 'Confirmed' : 'Not confirmed'}</p></div>`;
    }
    
    content += '</div></div>';
    
    content += '</div>';
    reviewContent.innerHTML = content;
}

// Step navigation click handlers (moved to main initialization)

// Info bubble functionality
function initializeInfoBubbles() {
    // Use event delegation to handle both existing and dynamically generated info icons
    document.addEventListener('mouseenter', function(e) {
        // Check if target is an Element before calling closest
        let icon = null;
        if (e.target && e.target.closest) {
            icon = e.target.closest('[data-popup-target]') || e.target.closest('.dependents-info-icon');
        }
        if (icon) {
            const targetId = icon.getAttribute('data-popup-target');
            const popup = document.getElementById(targetId);
            
            if (popup) {
                // Hide all other popups
                document.querySelectorAll('.dependents-popup').forEach(p => {
                    if (p !== popup) {
                        p.style.display = 'none';
                    }
                });
                
                // Show current popup
                popup.style.display = 'block';
            }
        }
    }, true);
    
    document.addEventListener('mouseleave', function(e) {
        // Check if target is an Element before calling closest
        let icon = null;
        if (e.target && e.target.closest) {
            icon = e.target.closest('[data-popup-target]') || e.target.closest('.dependents-info-icon');
        }
        if (icon) {
            const targetId = icon.getAttribute('data-popup-target');
            const popup = document.getElementById(targetId);
            
            if (popup) {
                // Delay hiding to allow mouse to move to popup
                setTimeout(() => {
                    if (!popup.matches(':hover') && !icon.matches(':hover')) {
                        popup.style.display = 'none';
                    }
                }, 100);
            }
        }
    }, true);
    
    // Handle popup hover events with event delegation
    document.addEventListener('mouseenter', function(e) {
        if (e.target && e.target.closest && e.target.closest('.dependents-popup')) {
            const popup = e.target.closest('.dependents-popup');
            popup.style.display = 'block';
        }
    }, true);
    
    document.addEventListener('mouseleave', function(e) {
        if (e.target && e.target.closest && e.target.closest('.dependents-popup')) {
            const popup = e.target.closest('.dependents-popup');
            popup.style.display = 'none';
        }
    }, true);
    
    // Close popup when clicking outside (backup for mobile)
    document.addEventListener('click', function(e) {
        const hasClosestMethod = e.target && e.target.closest;
        const inPopup = hasClosestMethod && e.target.closest('.dependents-popup');
        const onTarget = hasClosestMethod && e.target.closest('[data-popup-target]');
        const onIcon = hasClosestMethod && e.target.closest('.dependents-info-icon');
        
        if (!inPopup && !onTarget && !onIcon) {
            document.querySelectorAll('.dependents-popup').forEach(popup => {
                popup.style.display = 'none';
            });
        }
    });
}

class TrustRegistrationFormSubmissionManager extends FormSubmissionManager {
    constructor() {
        super('trustRegistrationForm', 'button[type="submit"]');
        this.form = document.getElementById('trustRegistrationForm');
        if (this.form) {
            // Disable HTML5 validation entirely to handle it manually
            this.form.setAttribute('novalidate', '');
        }
    }

    async handleSubmit(event) {
        event.preventDefault();

        // Prevent multiple submissions from double-clicks
        if (this.isSubmitting) return;
        this.isSubmitting = true;

        // Disable the submit button immediately
        if (this.submitButton) {
            this.submitButton.disabled = true;
            this.submitButton.textContent = 'Submitting...';
        }

        // Temporarily disable HTML5 validation on hidden fields before validation
        this.disableHiddenFieldValidation();

        // Show progress modal
        this.showProgress(0, 'Starting submission...');

        try {
            // Step 1: Validate form
            this.updateProgress(10, 'Validating form data...');
            if (!this.validateForm()) {
                this.hideProgress();
                // Re-enable validation and allow resubmission on validation failure
                this.enableHiddenFieldValidation();
                this.isSubmitting = false;
                if (this.submitButton) {
                    this.submitButton.disabled = false;
                    this.submitButton.textContent = 'Submit Trust Registration';
                }
                return;
            }

            // Step 2: Collect form data
            this.updateProgress(25, 'Collecting form data...');
            const formData = this.collectFormData();

            // Step 3: Save to database, generate PDF and send webhook (single step)
            this.updateProgress(50, 'Saving your submission...');
            const webhookResponse = await this.submitToWebhook(formData);

            if (!webhookResponse.success) {
                throw new Error(webhookResponse.message || 'Submission failed');
            }

            // Extract submission ID and client name for thank you page
            const submissionId = webhookResponse.submission_id || Date.now();
            const clientName = this.extractClientName(formData);

            // Step 4: Success — page will redirect, no need to re-enable the button
            this.updateProgress(100, 'Submission complete!');

            // Reset form
            this.form.reset();
            this.resetFormSections();

            // Re-enable validation
            this.enableHiddenFieldValidation();

            // Show success and redirect with submission details
            this.showSuccess('Your Trust Registration has been submitted successfully!', submissionId, clientName);

        } catch (error) {
            console.error('Trust Registration submission failed:', error);

            // Re-enable submission and button on error so the user can retry
            this.isSubmitting = false;
            if (this.submitButton) {
                this.submitButton.disabled = false;
                this.submitButton.textContent = 'Submit Trust Registration';
            }

            // Re-enable validation in error case
            this.enableHiddenFieldValidation();

            // Determine error type and show appropriate message
            if (error.message.includes('database') || error.message.includes('save')) {
                this.showError(
                    'There was a problem saving your submission to our database. Please try again or contact support if the problem persists.',
                    true
                );
            } else if (error.message.includes('validation')) {
                this.showError(
                    'Please check that all required fields are filled out correctly.',
                    false
                );
            } else {
                this.showError(
                    'An unexpected error occurred. Please try again or contact support if the problem persists.',
                    true
                );
            }
        }
    }

    validateForm() {
        const trusteeType = document.getElementById('trusteeType').value;
        
        if (!trusteeType) {
            alert('Please select a trustee type.');
            return false;
        }

        // Validate trustee-specific fields
        let trusteeValid = false;
        if (trusteeType === 'individual') {
            trusteeValid = this.validateIndividualTrustee();
        } else if (trusteeType === 'corporate') {
            trusteeValid = this.validateCorporateTrustee();
        }

        if (!trusteeValid) {
            return false;
        }

        // Validate all visible required fields (including dynamic ones)
        return this.validateAllVisibleRequiredFields();
    }

    validateAllVisibleRequiredFields() {
        const requiredFields = this.form.querySelectorAll('input[required], select[required], textarea[required]');
        
        for (const field of requiredFields) {
            // Only validate if field is visible
            if (!this.isFieldHidden(field)) {
                if (!field.value || !field.value.trim()) {
                    const fieldName = field.getAttribute('name') || field.id;
                    const label = this.getFieldLabelForElement(field);
                    alert(`Please fill in the ${label} field.`);
                    field.focus();
                    return false;
                }

                // Special validation for tax file numbers
                if (field.name && field.name.toLowerCase().includes('taxfilenumber')) {
                    if (!/^[0-9]{9}$/.test(field.value)) {
                        alert('Tax File Number must be exactly 9 digits.');
                        field.focus();
                        return false;
                    }
                }

                // Special validation for email fields
                if (field.type === 'email' || field.name && field.name.toLowerCase().includes('email')) {
                    if (!this.isValidEmail(field.value)) {
                        alert('Please enter a valid email address.');
                        field.focus();
                        return false;
                    }
                }
            }
        }

        return true;
    }

    validateIndividualTrustee() {
        const requiredFields = [
            'individualFirstName', 'individualLastName', 'individualEmail',
            'individualTelephone', 'individualDateOfBirth', 'individualCityOfBirth',
            'individualCountryOfBirth', 'individualTFN', 'individualDIN'
        ];

        for (const fieldId of requiredFields) {
            const field = document.getElementById(fieldId);
            // Only validate if field exists and is visible
            if (field && !this.isFieldHidden(field)) {
                if (!field.value.trim()) {
                    alert(`Please fill in the ${this.getFieldLabel(fieldId)} field.`);
                    field.focus();
                    return false;
                }
            }
        }

        // Validate email format (only if visible)
        const emailField = document.getElementById('individualEmail');
        if (emailField && !this.isFieldHidden(emailField)) {
            const email = emailField.value;
            if (!this.isValidEmail(email)) {
                alert('Please enter a valid email address.');
                emailField.focus();
                return false;
            }
        }

        // Validate TFN format (only if visible)
        const tfnField = document.getElementById('individualTFN');
        if (tfnField && !this.isFieldHidden(tfnField)) {
            const tfn = tfnField.value;
            if (!/^[0-9]{9}$/.test(tfn)) {
                alert('TFN must be exactly 9 digits.');
                tfnField.focus();
                return false;
            }
        }

        return true;
    }

    validateCorporateTrustee() {
        const isExistingCompany = document.getElementById('isExistingCompany').value;
        
        if (!isExistingCompany) {
            alert('Please specify if you are using an existing company.');
            return false;
        }

        if (isExistingCompany === 'yes') {
            return this.validateExistingCompany();
        } else if (isExistingCompany === 'no') {
            return this.validateNewCompany();
        }

        return false;
    }

    validateExistingCompany() {
        const acn = document.getElementById('existingCompanyACN').value;
        const name = document.getElementById('existingCompanyName').value;

        if (!acn || !name) {
            alert('Please fill in all existing company fields.');
            return false;
        }

        // Validate ACN format (9 digits, possibly with spaces)
        if (!/^[0-9]{3}[\s]?[0-9]{3}[\s]?[0-9]{3}$/.test(acn)) {
            alert('Please enter a valid ACN (9 digits).');
            document.getElementById('existingCompanyACN').focus();
            return false;
        }

        return true;
    }

    validateNewCompany() {
        const proposedName = document.getElementById('proposedCompanyName').value;
        const numberOfDirectors = document.getElementById('numberOfDirectors').value;

        if (!proposedName || !numberOfDirectors) {
            alert('Please fill in the proposed company name and number of directors.');
            return false;
        }

        // Validate director information
        const directorCount = parseInt(numberOfDirectors);
        for (let i = 1; i <= directorCount; i++) {
            if (!this.validateDirector(i)) {
                return false;
            }
        }

        return true;
    }

    validateDirector(directorNumber) {
        const requiredFields = [
            `director${directorNumber}FirstName`,
            `director${directorNumber}LastName`,
            `director${directorNumber}Email`,
            `director${directorNumber}Telephone`,
            `director${directorNumber}DateOfBirth`,
            `director${directorNumber}CityOfBirth`,
            `director${directorNumber}CountryOfBirth`,
            `director${directorNumber}TFN`,
            `director${directorNumber}DIN`,
            `director${directorNumber}IsShareHolder`
        ];

        for (const fieldId of requiredFields) {
            const field = document.getElementById(fieldId);
            if (!field || !field.value.trim()) {
                alert(`Please fill in the ${this.getFieldLabel(fieldId)} field for Director ${directorNumber}.`);
                field?.focus();
                return false;
            }
        }

        // Validate email
        const email = document.getElementById(`director${directorNumber}Email`).value;
        if (!this.isValidEmail(email)) {
            alert(`Please enter a valid email address for Director ${directorNumber}.`);
            document.getElementById(`director${directorNumber}Email`).focus();
            return false;
        }

        // Validate TFN
        const tfn = document.getElementById(`director${directorNumber}TFN`).value;
        if (!/^[0-9]{9}$/.test(tfn)) {
            alert(`TFN must be exactly 9 digits for Director ${directorNumber}.`);
            document.getElementById(`director${directorNumber}TFN`).focus();
            return false;
        }

        // Validate shareholder information
        const isShareHolder = document.getElementById(`director${directorNumber}IsShareHolder`).value;
        if (isShareHolder === 'yes') {
            const shares = document.getElementById(`director${directorNumber}NumberOfShares`).value;
            const value = document.getElementById(`director${directorNumber}ValuePerShare`).value;
            
            if (!shares || !value) {
                alert(`Please fill in share information for Director ${directorNumber}.`);
                return false;
            }
        } else if (isShareHolder === 'no') {
            const shareholderType = document.getElementById(`director${directorNumber}ShareHolderType`).value;
            if (!shareholderType) {
                alert(`Please specify who will hold shares for Director ${directorNumber}.`);
                return false;
            }
        }

        return true;
    }

    collectFormData() {
        const formData = {
            form_type: 'Trust Registration',
            submission_date: new Date().toISOString(),
            trustee_type: document.getElementById('trusteeType').value
        };

        // Collect individual trustee data
        if (formData.trustee_type === 'individual') {
            formData.individual_first_name = document.getElementById('individualFirstName').value;
            formData.individual_middle_name = document.getElementById('individualMiddleName').value || '';
            formData.individual_last_name = document.getElementById('individualLastName').value;
            formData.individual_email = document.getElementById('individualEmail').value;
            formData.individual_telephone = document.getElementById('individualTelephone').value;
            formData.individual_date_of_birth = document.getElementById('individualDateOfBirth').value;
            formData.individual_city_of_birth = document.getElementById('individualCityOfBirth').value;
            formData.individual_country_of_birth = document.getElementById('individualCountryOfBirth').value;
            formData.individual_tfn = document.getElementById('individualTFN').value;
            formData.individual_din = document.getElementById('individualDIN').value;
        }
        // Collect corporate trustee data
        else if (formData.trustee_type === 'corporate') {
            const isExistingCompany = document.getElementById('isExistingCompany').value;
            formData.is_existing_company = isExistingCompany === 'yes';

            if (isExistingCompany === 'yes') {
                formData.existing_company_acn = document.getElementById('existingCompanyACN').value;
                formData.existing_company_name = document.getElementById('existingCompanyName').value;
            } else if (isExistingCompany === 'no') {
                formData.proposed_company_name = document.getElementById('proposedCompanyName').value;
                formData.number_of_directors = parseInt(document.getElementById('numberOfDirectors').value);

                // Collect directors data as JSON array
                const directors = [];
                for (let i = 1; i <= formData.number_of_directors; i++) {
                    const director = this.collectDirectorData(i);
                    directors.push(director);
                }
                formData.directors = directors; // This will be serialized as JSON
            }
        }

        // Collect Trust Registration Detail fields
        formData.trust_name = document.getElementById('trustName').value || '';
        formData.trust_industry = document.getElementById('trustIndustry').value || '';
        formData.trust_business_activity = document.getElementById('trustBusinessActivity').value || '';
        
        // Collect checkbox values with null checks
        const abnRegCheckbox = document.getElementById('abnRegistration');
        const gstRegCheckbox = document.getElementById('gstRegistration');
        const paygRegCheckbox = document.getElementById('paygWithholdingRegistration');
        
        formData.abn_registration = abnRegCheckbox ? abnRegCheckbox.checked : false;
        formData.gst_registration = gstRegCheckbox ? gstRegCheckbox.checked : false;
        formData.payg_withholding_registration = paygRegCheckbox ? paygRegCheckbox.checked : false;

        // Collect Business Structure data
        const businessStructureTrustType = document.getElementById('trustType'); // FIX: Changed from 'businessStructureTrustType' to 'trustType'
        if (businessStructureTrustType && businessStructureTrustType.value) {
            formData.business_structure_trust_type = businessStructureTrustType.value;

            // Collect dynamic fields based on trust type
            if (businessStructureTrustType.value === 'Discretionary Trust') {
                const beneficiariesCount = document.getElementById('discretionaryBeneficiaries');
                if (beneficiariesCount && beneficiariesCount.value) {
                    formData.discretionary_beneficiaries_count = parseInt(beneficiariesCount.value);
                    
                    // Collect beneficiaries data as JSON array
                    const beneficiaries = [];
                    for (let i = 1; i <= formData.discretionary_beneficiaries_count; i++) {
                        const beneficiary = this.collectBeneficiaryData(i, 'discretionary');
                        if (beneficiary) {
                            beneficiaries.push(beneficiary);
                        }
                    }
                    formData.discretionary_beneficiaries = beneficiaries; // JSON array
                }
            } else if (businessStructureTrustType.value === 'Unit Trusts') {
                const unitHoldersCount = document.getElementById('unitHolders');
                if (unitHoldersCount && unitHoldersCount.value) {
                    formData.unit_holders_count = parseInt(unitHoldersCount.value);
                    
                    // Collect unit holders data as JSON array
                    const unitHolders = [];
                    for (let i = 1; i <= formData.unit_holders_count; i++) {
                        const unitHolder = this.collectUnitHolderData(i);
                        if (unitHolder) {
                            unitHolders.push(unitHolder);
                        }
                    }
                    formData.unit_holders = unitHolders; // JSON array
                }
            } else {
                // Other trust types with general beneficiaries
                const otherBeneficiariesCount = document.getElementById('otherBeneficiaries');
                if (otherBeneficiariesCount && otherBeneficiariesCount.value) {
                    formData.other_beneficiaries_count = parseInt(otherBeneficiariesCount.value);
                    
                    // Collect other beneficiaries data as JSON array
                    const otherBeneficiaries = [];
                    for (let i = 1; i <= formData.other_beneficiaries_count; i++) {
                        const beneficiary = this.collectBeneficiaryData(i, 'other');
                        if (beneficiary) {
                            otherBeneficiaries.push(beneficiary);
                        }
                    }
                    formData.other_beneficiaries = otherBeneficiaries; // JSON array
                }
            }
        }

        // Collect Declarations and Signature data
        const accountantNominationCheckbox = document.getElementById('accountantNomination');
        formData.accountant_nomination = accountantNominationCheckbox ? accountantNominationCheckbox.checked : false;
        
        const asicAgent = document.getElementById('asicRegisteredAgent');
        if (asicAgent && asicAgent.value) {
            formData.asic_registered_agent = asicAgent.value;
        }

        const signatureFullName = document.getElementById('signatureFullName');
        if (signatureFullName && signatureFullName.value) {
            formData.signature_full_name = signatureFullName.value;
        }

        const signatureDate = document.getElementById('signatureDate');
        if (signatureDate && signatureDate.value) {
            formData.signature_date = signatureDate.value;
        }

        // Collect signature canvas data
        if (window.signaturePad && !window.signaturePad.isEmpty()) {
            formData.signature_data = window.signaturePad.toDataURL();
        }

        // Collect manual signature confirmation with null check
        const confirmationCheckbox = document.getElementById('trustManualSignatureConfirmation');
        formData.manual_signature_confirmation = confirmationCheckbox ? confirmationCheckbox.checked : false;

        return formData;
    }

    collectDirectorData(directorNumber) {
        const isShareHolder = document.getElementById(`director${directorNumber}IsShareHolder`).value === 'yes';

        const director = {
            first_name: document.getElementById(`director${directorNumber}FirstName`).value,
            middle_name: document.getElementById(`director${directorNumber}MiddleName`).value || '',
            last_name: document.getElementById(`director${directorNumber}LastName`).value,
            email: document.getElementById(`director${directorNumber}Email`).value,
            telephone: document.getElementById(`director${directorNumber}Telephone`).value,
            residential_address: document.getElementById(`director${directorNumber}Address`)?.value || '',
            residential_suburb: document.getElementById(`director${directorNumber}Suburb`)?.value || '',
            residential_state: document.getElementById(`director${directorNumber}State`)?.value || '',
            residential_postcode: document.getElementById(`director${directorNumber}Postcode`)?.value || '',
            date_of_birth: document.getElementById(`director${directorNumber}DateOfBirth`).value,
            city_of_birth: document.getElementById(`director${directorNumber}CityOfBirth`).value,
            country_of_birth: document.getElementById(`director${directorNumber}CountryOfBirth`).value,
            tfn: document.getElementById(`director${directorNumber}TFN`).value,
            din: document.getElementById(`director${directorNumber}DIN`).value,
            is_shareholder: isShareHolder
        };

        if (isShareHolder) {
            const nominateMyselfCheckbox = document.getElementById(`director${directorNumber}NominateMyself`);
            const beneficiallyHeldCheckbox = document.getElementById(`director${directorNumber}BeneficiallyHeld`);

            director.nominate_myself = nominateMyselfCheckbox ? nominateMyselfCheckbox.checked : false;
            director.shareholder_type = document.getElementById(`director${directorNumber}ShareHolderType`)?.value || 'individual';
            director.number_of_shares = parseInt(document.getElementById(`director${directorNumber}NumberOfShares`).value) || 0;
            director.share_class = document.getElementById(`director${directorNumber}ShareClass`)?.value || '';
            director.value_per_share = parseFloat(document.getElementById(`director${directorNumber}ValuePerShare`).value) || 0;
            director.beneficially_held = beneficiallyHeldCheckbox ? beneficiallyHeldCheckbox.checked : false;
        } else {
            director.shareholder_type = document.getElementById(`director${directorNumber}ShareHolderType`).value;
        }

        return director;
    }

    collectBeneficiaryData(beneficiaryNumber, type) {
        const prefix = type === 'discretionary' ? `discretionaryBeneficiary${beneficiaryNumber}` : `otherBeneficiary${beneficiaryNumber}`;

        // Check if the beneficiary elements exist
        const firstNameEl = document.getElementById(`${prefix}FirstName`);
        const lastNameEl = document.getElementById(`${prefix}LastName`);

        if (!firstNameEl || !lastNameEl) {
            return null; // Skip if elements don't exist
        }

        const beneficiary = {
            first_name: firstNameEl.value || '',
            middle_name: document.getElementById(`${prefix}MiddleName`)?.value || '',
            last_name: lastNameEl.value || '',
            email: document.getElementById(`${prefix}Email`)?.value || '',
            telephone: document.getElementById(`${prefix}Telephone`)?.value || '',
            date_of_birth: document.getElementById(`${prefix}DateOfBirth`)?.value || '',
            relationship: document.getElementById(`${prefix}Relationship`)?.value || '',
            residential_address: document.getElementById(`${prefix}Address`)?.value || '',
            residential_suburb: document.getElementById(`${prefix}Suburb`)?.value || '',
            residential_state: document.getElementById(`${prefix}State`)?.value || '',
            residential_postcode: document.getElementById(`${prefix}Postcode`)?.value || '',
            tfn: document.getElementById(`${prefix}TFN`)?.value || '',
            percentage_entitlement: parseFloat(document.getElementById(`${prefix}PercentageEntitlement`)?.value) || 0
        };

        return beneficiary;
    }

    collectUnitHolderData(unitHolderNumber) {
        const prefix = `unitHolder${unitHolderNumber}`;

        // Check holder type to determine which fields to collect
        const holderTypeEl = document.getElementById(`${prefix}HolderType`);
        if (!holderTypeEl) {
            return null; // Skip if element doesn't exist
        }

        const holderType = holderTypeEl.value;

        const unitHolder = {
            holder_type: holderType
        };

        if (holderType === 'individual') {
            // Collect individual unit holder fields
            const firstNameEl = document.getElementById(`${prefix}FirstName`);
            const lastNameEl = document.getElementById(`${prefix}LastName`);

            if (!firstNameEl || !lastNameEl) {
                return null; // Skip if required elements don't exist
            }

            unitHolder.first_name = firstNameEl.value || '';
            unitHolder.middle_name = document.getElementById(`${prefix}MiddleName`)?.value || '';
            unitHolder.last_name = lastNameEl.value || '';
            unitHolder.email = document.getElementById(`${prefix}Email`)?.value || '';
            unitHolder.telephone = document.getElementById(`${prefix}Telephone`)?.value || '';
            unitHolder.date_of_birth = document.getElementById(`${prefix}DateOfBirth`)?.value || '';
            unitHolder.residential_address = document.getElementById(`${prefix}Address`)?.value || '';
            unitHolder.residential_suburb = document.getElementById(`${prefix}Suburb`)?.value || '';
            unitHolder.residential_state = document.getElementById(`${prefix}State`)?.value || '';
            unitHolder.residential_postcode = document.getElementById(`${prefix}Postcode`)?.value || '';
            unitHolder.tfn = document.getElementById(`${prefix}TFN`)?.value || '';
        } else if (holderType === 'company') {
            // Collect company unit holder fields
            const companyNameEl = document.getElementById(`${prefix}CompanyName`);
            if (!companyNameEl) {
                return null;
            }

            unitHolder.company_name = companyNameEl.value || '';
            unitHolder.abn = document.getElementById(`${prefix}ABN`)?.value || '';
            unitHolder.company_address = document.getElementById(`${prefix}CompanyAddress`)?.value || '';
        }

        // Collect unit information (common for both types)
        unitHolder.number_of_units = parseInt(document.getElementById(`${prefix}NumberOfUnits`)?.value) || 0;
        unitHolder.value_per_unit = parseFloat(document.getElementById(`${prefix}ValuePerUnit`)?.value) || 0;
        unitHolder.total_investment = parseFloat(document.getElementById(`${prefix}TotalInvestment`)?.value) || 0;

        return unitHolder;
    }

    async submitToDatabase(formData) {
        // Convert form data to the expected format for the API
        const submissionData = {
            // Step 1: Trustee Information
            trusteeType: formData.trustee_type,
            
            // Individual Trustee Fields
            individualFirstName: formData.individual_first_name || null,
            individualMiddleName: formData.individual_middle_name || null,
            individualLastName: formData.individual_last_name || null,
            individualEmail: formData.individual_email || null,
            individualTelephone: formData.individual_telephone || null,
            individualDateOfBirth: convertAustralianDateToISO(formData.individual_date_of_birth),
            individualCityOfBirth: formData.individual_city_of_birth || null,
            individualCountryOfBirth: formData.individual_country_of_birth || null,
            individualTFN: formData.individual_tfn || null,
            individualDIN: formData.individual_din || null,
            
            // Corporate Trustee Fields
            isExistingCompany: formData.is_existing_company || null,
            existingCompanyACN: formData.existing_company_acn || null,
            existingCompanyName: formData.existing_company_name || null,
            proposedCompanyName: formData.proposed_company_name || null,
            numberOfDirectors: formData.number_of_directors || null,
            directorsData: formData.directors || null,
            
            // Step 2: Trust Registration Details
            trustName: formData.trust_name || null,
            trustIndustry: formData.trust_industry || null,
            trustBusinessActivity: formData.trust_business_activity || null,
            abnRegistration: formData.abn_registration || false,
            gstRegistration: formData.gst_registration || false,
            paygWithholdingRegistration: formData.payg_withholding_registration || false,
            
            // Step 3: Business Structure
            businessStructureTrustType: formData.business_structure_trust_type || null,
            discretionaryBeneficiariesCount: formData.discretionary_beneficiaries_count || null,
            discretionaryBeneficiariesData: formData.discretionary_beneficiaries || null,
            unitHoldersCount: formData.unit_holders_count || null,
            unitHoldersData: formData.unit_holders || null,
            otherBeneficiariesCount: formData.other_beneficiaries_count || null,
            otherBeneficiariesData: formData.other_beneficiaries || null,
            
            // Step 4: Declarations and Nominations
            accountantNomination: formData.accountant_nomination || false,
            asicRegisteredAgent: formData.asic_registered_agent || null,
            signatureFullName: formData.signature_full_name || null,
            signatureDate: formData.signature_date || null,
            signatureData: formData.signature_data || null,
            manualSignatureConfirmation: formData.manual_signature_confirmation || false
        };

        const response = await fetch('/api/TrustRegistration/submit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(submissionData)
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Database save failed: ${errorData.message || response.statusText}`);
        }

        return await response.json();
    }

    async submitToWebhook(formData) {
        const response = await fetch('/Forms/TrustRegistrationWebhookProxy', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });

        if (!response.ok) {
            throw new Error(`Webhook failed: ${response.statusText}`);
        }

        return await response.json();
    }

    resetFormSections() {
        // Hide all sections
        document.getElementById('individualTrusteeSection').classList.add('hidden');
        document.getElementById('corporateTrusteeSection').classList.add('hidden');
        document.getElementById('existingCompanyFields').classList.add('hidden');
        document.getElementById('newCompanyFields').classList.add('hidden');
        
        // Clear directors container
        document.getElementById('directorsContainer').innerHTML = '';
        
        // Remove all required attributes
        this.setIndividualFieldsRequired(false);
        this.setCorporateFieldsRequired(false);
        this.setExistingCompanyFieldsRequired(false);
        this.setNewCompanyFieldsRequired(false);
    }

    getFieldLabel(fieldId) {
        const labels = {
            'individualFirstName': 'First Name',
            'individualLastName': 'Last Name',
            'individualEmail': 'Email',
            'individualTelephone': 'Telephone',
            'individualDateOfBirth': 'Date of Birth',
            'individualCityOfBirth': 'City of Birth',
            'individualCountryOfBirth': 'Country of Birth',
            'individualTFN': 'TFN',
            'individualDIN': 'DIN'
        };

        // Handle director fields
        const directorMatch = fieldId.match(/director(\d+)(.+)/);
        if (directorMatch) {
            const directorNumber = directorMatch[1];
            const fieldName = directorMatch[2];
            const fieldLabels = {
                'FirstName': 'First Name',
                'LastName': 'Last Name',
                'Email': 'Email',
                'Telephone': 'Telephone',
                'DateOfBirth': 'Date of Birth',
                'CityOfBirth': 'City of Birth',
                'CountryOfBirth': 'Country of Birth',
                'TFN': 'TFN',
                'DIN': 'DIN',
                'IsShareHolder': 'Shareholder Status'
            };
            return fieldLabels[fieldName] || fieldName;
        }

        return labels[fieldId] || fieldId;
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    getFieldLabelForElement(field) {
        // Try to get label from the field's ID first
        if (field.id) {
            const label = this.getFieldLabel(field.id);
            if (label !== field.id) {
                return label;
            }
        }

        // Try to find a label element associated with this field
        const label = document.querySelector(`label[for="${field.id}"]`);
        if (label) {
            return label.textContent.replace('*', '').trim();
        }

        // Fallback to parsing field name/id
        const fieldName = field.name || field.id;
        if (fieldName) {
            // Handle beneficiary fields
            if (fieldName.includes('BeneficiaryFirstName')) return 'Beneficiary First Name';
            if (fieldName.includes('BeneficiaryLastName')) return 'Beneficiary Last Name';
            if (fieldName.includes('BeneficiaryTaxFileNumber')) return 'Beneficiary Tax File Number';
            if (fieldName.includes('BeneficiaryDOB')) return 'Beneficiary Date of Birth';
            if (fieldName.includes('BeneficiaryAddress')) return 'Beneficiary Address';
            
            // Handle unit holder fields
            if (fieldName.includes('unitHolder')) return 'Unit Holder';
            
            // Convert camelCase to readable format
            return fieldName.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        }

        return 'Field';
    }

    setIndividualFieldsRequired(required) {
        const fields = ['individualFirstName', 'individualLastName', 'individualEmail', 'individualTelephone', 'individualDateOfBirth', 'individualCityOfBirth', 'individualCountryOfBirth', 'individualTFN', 'individualDIN'];
        fields.forEach(field => {
            const element = document.getElementById(field);
            if (element) {
                if (required) {
                    element.setAttribute('required', '');
                } else {
                    element.removeAttribute('required');
                }
            }
        });
    }

    setCorporateFieldsRequired(required) {
        const isExistingField = document.getElementById('isExistingCompany');
        if (isExistingField) {
            if (required) {
                isExistingField.setAttribute('required', '');
            } else {
                isExistingField.removeAttribute('required');
            }
        }
    }

    setExistingCompanyFieldsRequired(required) {
        const fields = ['existingCompanyACN', 'existingCompanyName'];
        fields.forEach(field => {
            const element = document.getElementById(field);
            if (element) {
                if (required) {
                    element.setAttribute('required', '');
                } else {
                    element.removeAttribute('required');
                }
            }
        });
    }

    setNewCompanyFieldsRequired(required) {
        const fields = ['proposedCompanyName', 'numberOfDirectors'];
        fields.forEach(field => {
            const element = document.getElementById(field);
            if (element) {
                if (required) {
                    element.setAttribute('required', '');
                } else {
                    element.removeAttribute('required');
                }
            }
        });
    }

    // Helper methods to handle HTML5 validation on hidden fields
    disableHiddenFieldValidation() {
        // Store current required state and disable validation on hidden fields
        this.hiddenFieldsState = new Map();

        // Get all form inputs/selects/textareas with required attribute
        const requiredInputs = this.form.querySelectorAll('input[required], select[required], textarea[required]');
        requiredInputs.forEach(input => {
            // Check if the field or its parent is hidden
            const isHidden = this.isFieldHidden(input);
            if (isHidden) {
                // Store original state and remove required attribute
                this.hiddenFieldsState.set(input.id || input.name, {
                    element: input,
                    wasRequired: true
                });
                input.removeAttribute('required');
            }
        });
        // Also check for dynamically generated beneficiary fields by name pattern
        const dynamicRequiredInputs = this.form.querySelectorAll('[name*="BeneficiaryTaxFileNumber"][required]');
        dynamicRequiredInputs.forEach(input => {
            const isHidden = this.isFieldHidden(input);
            if (isHidden) {
                this.hiddenFieldsState.set(input.id || input.name, {
                    element: input,
                    wasRequired: true
                });
                input.removeAttribute('required');
            }
        });
    }

    enableHiddenFieldValidation() {
        // Restore required attribute to previously hidden fields
        if (this.hiddenFieldsState) {
            this.hiddenFieldsState.forEach((state, fieldId) => {
                if (state.wasRequired && state.element) {
                    state.element.setAttribute('required', '');
                }
            });
            this.hiddenFieldsState.clear();
        }
    }

    isFieldHidden(element) {
        // Check if element or any parent has 'hidden' class or display:none
        let current = element;
        while (current && current !== document.body) {
            const computedStyle = window.getComputedStyle(current);
            if (current.classList.contains('hidden') || 
                computedStyle.display === 'none' || 
                computedStyle.visibility === 'hidden') {
                return true;
            }
            current = current.parentElement;
        }
        return false;
    }

    // Progress modal methods
    showProgress(percentage, message) {
        // Create progress modal if it doesn't exist
        if (!document.getElementById('progressModal')) {
            this.createProgressModal();
        }
        
        const modal = document.getElementById('progressModal');
        const progressBar = document.getElementById('progressBar');
        const progressText = document.getElementById('progressText');
        
        if (modal && progressBar && progressText) {
            modal.classList.remove('hidden');
            progressBar.style.width = `${percentage}%`;
            progressText.textContent = message;
        }
    }

    updateProgress(percentage, message) {
        const progressBar = document.getElementById('progressBar');
        const progressText = document.getElementById('progressText');
        
        if (progressBar && progressText) {
            progressBar.style.width = `${percentage}%`;
            progressText.textContent = message;
        }
    }

    hideProgress() {
        const modal = document.getElementById('progressModal');
        if (modal) {
            modal.classList.add('hidden');
        }
    }

    extractClientName(formData) {
        // Try to get client name from different possible sources
        if (formData.trustee_type === 'Individual') {
            const firstName = formData.individual_first_name || '';
            const lastName = formData.individual_last_name || '';
            return `${firstName} ${lastName}`.trim();
        } else if (formData.trustee_type === 'Corporate') {
            return formData.existing_company_name || formData.proposed_company_name || '';
        }
        return '';
    }

    showSuccess(message, submissionId = null, clientName = null) {
        // Show final success state in the progress modal
        const progressBar = document.getElementById('progressBar');
        const progressText = document.getElementById('progressText');
        
        if (progressBar && progressText) {
            progressBar.style.width = '100%';
            progressBar.classList.add('bg-green-500');
            progressText.innerHTML = '<i class="fas fa-check-circle text-green-600 mr-2"></i>Submission Complete!';
        }
        
        // Show completion for a moment, then redirect
        setTimeout(() => {
            this.hideProgress();
            // Redirect to thank you page with submission details
            let thankYouUrl = '/Forms/TrustRegistrationThankYou';
            const params = new URLSearchParams();
            
            if (submissionId) {
                params.append('submissionId', submissionId.toString());
            }
            if (clientName) {
                params.append('clientName', clientName);
            }
            
            if (params.toString()) {
                thankYouUrl += '?' + params.toString();
            }
            
            window.location.href = thankYouUrl;
        }, 2000); // Wait 2 seconds to let user see the completion
    }

    showError(message, canRetry = false) {
        this.hideProgress();
        if (canRetry) {
            alert(`Error: ${message}\n\nPlease try again or contact support if the problem persists.`);
        } else {
            alert(`Error: ${message}`);
        }
    }

    createProgressModal() {
        const modal = document.createElement('div');
        modal.id = 'progressModal';
        modal.className = 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 hidden';
        modal.innerHTML = `
            <div class="bg-white rounded-lg p-8 max-w-md w-full mx-4">
                <div class="text-center">
                    <div class="mb-4">
                        <svg class="animate-spin -ml-1 mr-3 h-8 w-8 text-gold-500 mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                    <h3 class="text-lg font-medium text-gray-900 mb-4">Processing Submission</h3>
                    <div class="w-full bg-gray-200 rounded-full h-2 mb-4">
                        <div id="progressBar" class="bg-gold-500 h-2 rounded-full transition-all duration-300" style="width: 0%"></div>
                    </div>
                    <p id="progressText" class="text-sm text-gray-600">Starting submission...</p>
                </div>
            </div>
        `;
        document.body.appendChild(modal);
    }
}

// Initialize everything when the page loads - SINGLE INITIALIZATION POINT
// This prevents multiple event listener registrations that cause duplicate submissions
document.addEventListener('DOMContentLoaded', function() {
    // Only initialize if the form exists on this page
    if (!document.getElementById('trustRegistrationForm')) {
        return;
    }

    // 1. Initialize the form submission manager (handles form submit event)
    new TrustRegistrationFormSubmissionManager();

    // 2. Initialize step navigation
    document.querySelectorAll('.step-nav-btn').forEach(btn => {
        btn.addEventListener('click', function() {
            const targetStep = parseInt(this.dataset.step);

            // Only allow navigation to completed steps or the next step
            if (targetStep <= currentStep + 1) {
                const stepDifference = targetStep - currentStep;

                if (stepDifference > 0) {
                    // Moving forward - validate current step
                    if (validateCurrentStep()) {
                        changeStep(stepDifference);
                    }
                } else {
                    // Moving backward - no validation needed
                    changeStep(stepDifference);
                }
            }
        });
    });

    // 3. Initialize wizard progress
    updateProgress();
    updateNavigationButtons();

    // 4. Initialize info bubble functionality
    initializeInfoBubbles();

    // 5. Initialize signature canvas if Step 4 is visible
    if (document.getElementById('step-4') && !document.getElementById('step-4').classList.contains('hidden')) {
        setTimeout(initializeTrustSignatureCanvas, 100);
    }

    // 6. Setup signature canvas initialization for when Step 4 becomes visible
    const originalChangeStep = window.changeStep;
    window.changeStep = function(stepNumber) {
        originalChangeStep(stepNumber);
        if (stepNumber === 4) {
            setTimeout(initializeTrustSignatureCanvas, 100);
        }
    };
});

// Global functions for form interactions

// Trustee type selection
function toggleTrusteeFields() {
    const trusteeType = document.getElementById('trusteeType').value;
    const individualSection = document.getElementById('individualTrusteeSection');
    const corporateSection = document.getElementById('corporateTrusteeSection');
    
    // Store the selection for later use
    window.selectedTrusteeType = trusteeType;
    
    if (trusteeType === 'individual') {
        if (individualSection) {
            individualSection.classList.remove('hidden');
        }
        if (corporateSection) {
            corporateSection.classList.add('hidden');
        }
        setIndividualFieldsRequired(true);
        setCorporateFieldsRequired(false);
    } else if (trusteeType === 'corporate') {
        if (individualSection) {
            individualSection.classList.add('hidden');
        }
        if (corporateSection) {
            corporateSection.classList.remove('hidden');
        }
        setIndividualFieldsRequired(false);
        setCorporateFieldsRequired(true);
    } else {
        if (individualSection) {
            individualSection.classList.add('hidden');
        }
        if (corporateSection) {
            corporateSection.classList.add('hidden');
        }
        setIndividualFieldsRequired(false);
        setCorporateFieldsRequired(false);
    }
}

// Company type selection
function toggleCompanyFields() {
    const isExisting = document.getElementById('isExistingCompany').value;
    const existingFields = document.getElementById('existingCompanyFields');
    const newFields = document.getElementById('newCompanyFields');
    
    if (isExisting === 'yes') {
        existingFields.classList.remove('hidden');
        newFields.classList.add('hidden');
        setExistingCompanyFieldsRequired(true);
        setNewCompanyFieldsRequired(false);
    } else if (isExisting === 'no') {
        existingFields.classList.add('hidden');
        newFields.classList.remove('hidden');
        setExistingCompanyFieldsRequired(false);
        setNewCompanyFieldsRequired(true);
    } else {
        existingFields.classList.add('hidden');
        newFields.classList.add('hidden');
        setExistingCompanyFieldsRequired(false);
        setNewCompanyFieldsRequired(false);
    }
}

// Generate director fields based on number selected
function generateDirectorFields() {
    const numberOfDirectors = parseInt(document.getElementById('numberOfDirectors').value);
    const container = document.getElementById('directorsContainer');
    
    container.innerHTML = '';
    
    for (let i = 1; i <= numberOfDirectors; i++) {
        const directorHtml = createDirectorFields(i);
        container.insertAdjacentHTML('beforeend', directorHtml);
    }
}

// Create reusable shareholder questions HTML
function createShareholderQuestions(directorNumber, shareholderType) {
    const prefix = `director${directorNumber}${shareholderType}`;
    return `
        <div class="bg-gray-50 rounded-lg p-4">
            <h6 class="text-md font-medium text-gray-700 mb-3">Shareholder Questions</h6>
            <div class="mb-4">
                <label for="${prefix}NumberOfShares" class="block text-sm font-medium text-gray-700 mb-1">
                    Specify how many shares will be issued to the shareholder? 
                    <div class="relative inline-block">
                        <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" style="color: #6b7280 !important;" data-popup-target="sharesInfo${directorNumber}${shareholderType}"></i>
                        
                        <!-- Shares Info Popup -->
                        <div id="sharesInfo${directorNumber}${shareholderType}" 
                             class="dependents-popup dependents-popup-arrow-left absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                             style="display: none;">
                            
                            <!-- Popup Header -->
                            <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                <i class="fas fa-exclamation-triangle text-gold-600 mr-2"></i>
                                <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                            </div>
                            
                            <!-- Popup Content -->
                            <div class="text-sm text-gray-700 leading-relaxed">
                                <p>
                                    Generally you can issue shares at $1 fully paid shares beneficially held, for example, if there are three (3) directors, you can issue 50 shares per stakeholder fully paid at $1 per share and depending on the purpose of the entity, they may be beneficially held.
                                </p>
                            </div>
                        </div>
                    </div>
                    <span class="text-red-500">*</span>
                </label>
                <div class="flex items-center space-x-2">
                    <input type="number" 
                           id="${prefix}NumberOfShares" 
                           name="${prefix}NumberOfShares" 
                           min="1" 
                           max="100" 
                           class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                    <span class="text-sm text-gray-600">shares</span>
                    <span class="text-sm text-gray-600">$</span>
                    <input type="number" 
                           id="${prefix}ValuePerShare" 
                           name="${prefix}ValuePerShare" 
                           min="0.01" 
                           step="0.01" 
                           class="w-24 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" 
                           placeholder="0.00">
                    <span class="text-sm text-gray-600">per share</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="${prefix}BeneficiallyHeld" class="flex items-center">
                    <input type="checkbox" 
                           id="${prefix}BeneficiallyHeld" 
                           name="${prefix}BeneficiallyHeld" 
                           class="mr-2">
                    <span class="text-sm font-medium text-gray-700">Beneficially held</span>
                    <div class="relative inline-block ml-1">
                        <i class="fas fa-info-circle dependents-info-icon cursor-pointer" style="color: #6b7280 !important;" data-popup-target="beneficiallyHeldInfo${directorNumber}${shareholderType}"></i>
                        
                        <!-- Beneficially Held Info Popup -->
                        <div id="beneficiallyHeldInfo${directorNumber}${shareholderType}" 
                             class="dependents-popup dependents-popup-arrow-left absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                             style="display: none;">
                            
                            <!-- Popup Header -->
                            <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                <i class="fas fa-exclamation-triangle text-gold-600 mr-2"></i>
                                <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                            </div>
                            
                            <!-- Popup Content -->
                            <div class="text-sm text-gray-700 leading-relaxed">
                                <p>
                                    Beneficially held shares mean they are held for a direct benefit such as dividend distribution, however, if they are held on behalf of another entity or individual, then they are not beneficially held.
                                </p>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        </div>
    `;
}

// Create director fields HTML
function createDirectorFields(directorNumber) {
    return `
        <div class="bg-white border border-gray-200 rounded-lg p-4">
            <h4 class="text-lg font-medium text-gold-600 mb-3">Director ${directorNumber} Information</h4>
            <p class="text-sm text-gray-600 mb-4">Please provide the following information</p>
            
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                    <label for="director${directorNumber}FirstName" class="block text-sm font-medium text-gray-700 mb-1">First name <span class="text-red-500">*</span></label>
                    <input type="text" id="director${directorNumber}FirstName" name="director${directorNumber}FirstName" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}MiddleName" class="block text-sm font-medium text-gray-700 mb-1">Middle name</label>
                    <input type="text" id="director${directorNumber}MiddleName" name="director${directorNumber}MiddleName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}LastName" class="block text-sm font-medium text-gray-700 mb-1">Last name <span class="text-red-500">*</span></label>
                    <input type="text" id="director${directorNumber}LastName" name="director${directorNumber}LastName" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div class="md:col-span-2 lg:col-span-3">
                    <label for="director${directorNumber}Address" class="block text-sm font-medium text-gray-700 mb-1">Residential address <span class="text-red-500">*</span></label>
                    <textarea id="director${directorNumber}Address" name="director${directorNumber}Address" rows="3" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Enter full residential address"></textarea>
                </div>
                <div>
                    <label for="director${directorNumber}Email" class="block text-sm font-medium text-gray-700 mb-1">Email <span class="text-red-500">*</span></label>
                    <input type="email" id="director${directorNumber}Email" name="director${directorNumber}Email" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}Telephone" class="block text-sm font-medium text-gray-700 mb-1">Telephone <span class="text-red-500">*</span></label>
                    <input type="tel" id="director${directorNumber}Telephone" name="director${directorNumber}Telephone" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}DateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Date of birth <span class="text-red-500">*</span></label>
                    <input type="text" id="director${directorNumber}DateOfBirth" name="director${directorNumber}DateOfBirth" placeholder="DD/MM/YYYY" pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\\d{4}$" title="Please enter date in DD/MM/YYYY format" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}CityOfBirth" class="block text-sm font-medium text-gray-700 mb-1">City or suburb of birth <span class="text-red-500">*</span></label>
                    <input type="text" id="director${directorNumber}CityOfBirth" name="director${directorNumber}CityOfBirth" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}CountryOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Country of birth <span class="text-red-500">*</span></label>
                    <input type="text" id="director${directorNumber}CountryOfBirth" name="director${directorNumber}CountryOfBirth" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="director${directorNumber}TFN" class="block text-sm font-medium text-gray-700 mb-1">Personal Tax File Number (TFN) <span class="text-red-500">*</span></label>
                    <input type="text" id="director${directorNumber}TFN" name="director${directorNumber}TFN" pattern="[0-9]{9}" maxlength="9" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <div class="relative">
                        <label for="director${directorNumber}DIN" class="block text-sm font-medium text-gray-700 mb-1">
                            Director Identification Number (DIN) <span class="text-red-500">*</span>
                            <div class="relative inline-block">
                                <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" style="color: #6b7280 !important;" data-popup-target="directorDinInfo${directorNumber}"></i>
                                
                                <!-- DIN Info Popup for Director -->
                                <div id="directorDinInfo${directorNumber}" 
                                     class="dependents-popup dependents-popup-arrow-left absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                                     style="display: none;">
                                    
                                    <!-- Popup Header -->
                                    <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                        <i class="fas fa-exclamation-triangle text-gold-600 mr-2"></i>
                                        <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                                    </div>
                                    
                                    <!-- Popup Content -->
                                    <div class="text-sm text-gray-700 leading-relaxed">
                                        <p class="mb-2">
                                            ASIC requires directors appointed before 1 November 2021 to apply for a directors identification number (DIN) by 30 November 2022.
                                        </p>
                                        <p class="mb-2">
                                            New directors appointed to a company between 1 November 2021 and 4 April 2022 need to apply for DIN within 28 days from their appointment and finally from 5 April 2022 any new director intending to be appointed as director must hold DIN before being appointed.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                    <input type="text" id="director${directorNumber}DIN" name="director${directorNumber}DIN" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
            </div>
            
            <!-- Shareholding Information -->
            <div class="mt-6">
                <h5 class="text-md font-medium text-gray-700 mb-3">Shareholding Information</h5>
                <div class="mb-3">
                    <label for="director${directorNumber}IsShareHolder" class="block text-sm font-medium text-gray-700 mb-1">Will this director hold shares? <span class="text-red-500">*</span></label>
                    <select id="director${directorNumber}IsShareHolder" name="director${directorNumber}IsShareHolder" required class="w-full md:w-1/3 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" onchange="toggleShareholderFields(${directorNumber})">
                        <option value="">Select...</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                
                <!-- If Yes - Show shareholding fields -->
                <div id="director${directorNumber}ShareholderFields" class="hidden">
                    <div class="mb-3">
                        <label for="director${directorNumber}NominateMyself" class="flex items-center">
                            <input type="checkbox" id="director${directorNumber}NominateMyself" name="director${directorNumber}NominateMyself" class="mr-2">
                            <span class="text-sm font-medium text-gray-700">I nominate myself as a shareholder</span>
                        </label>
                    </div>
                    
                    <!-- Shareholder Questions -->
                    ${createShareholderQuestions(directorNumber, 'Director')}
                    
                    <div class="mb-3">
                        <label for="director${directorNumber}BeneficiallyHeld" class="flex items-center">
                            <input type="checkbox" id="director${directorNumber}BeneficiallyHeld" name="director${directorNumber}BeneficiallyHeld" class="mr-2">
                            <span class="text-sm font-medium text-gray-700">The shares will be beneficially held (i.e., not held on trust for another person)</span>
                        </label>
                    </div>
                </div>
                
                <!-- If No - Show who will hold shares -->
                <div id="director${directorNumber}NonShareholderFields" class="hidden">
                    <div class="mb-3">
                        <div class="relative">
                            <label for="director${directorNumber}ShareHolderType" class="block text-sm font-medium text-gray-700 mb-1">
                                Who will hold shares for this officeholder? <span class="text-red-500">*</span>
                                <div class="relative inline-block">
                                    <i class="fas fa-info-circle dependents-info-icon ml-1 cursor-pointer" style="color: #6b7280 !important;" data-popup-target="shareholderInfo${directorNumber}"></i>
                                    
                                    <!-- Shareholder Info Popup -->
                                    <div id="shareholderInfo${directorNumber}" 
                                         class="dependents-popup dependents-popup-arrow-left absolute left-full top-1/2 transform -translate-y-1/2 ml-2 w-80 bg-white border-2 border-gold-200 rounded-lg shadow-xl p-4 z-50"
                                         style="display: none;">
                                        
                                        <!-- Popup Header -->
                                        <div class="flex items-center mb-3 pb-2 border-b border-gold-100">
                                            <i class="fas fa-exclamation-triangle text-gold-600 mr-2"></i>
                                            <h4 class="font-semibold text-gray-800 text-sm">Important Information</h4>
                                        </div>
                                        
                                        <!-- Popup Content -->
                                        <div class="text-sm text-gray-700 leading-relaxed">
                                            <p>
                                                A nominee shareholder is just another person who is nominated by you to hold shares in a private company on your behalf, it's important that you enter into a nominee shareholder agreement and the shares are generally not held beneficially.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                        <select id="director${directorNumber}ShareHolderType" name="director${directorNumber}ShareHolderType" class="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" onchange="toggleNomineeFields(${directorNumber})">
                            <option value="">Select...</option>
                            <option value="nominee-individual">Nominee Individual</option>
                            <option value="company">Company</option>
                            <option value="trust">Trust</option>
                        </select>
                    </div>
                    
                    <!-- Nominee Individual Fields -->
                    <div id="director${directorNumber}NomineeFields" class="hidden mt-4">
                        <div class="mb-3">
                            <label for="director${directorNumber}NomineeIsDirector" class="block text-sm font-medium text-gray-700 mb-1">Is the nominee individual holding the shares also a director? <span class="text-red-500">*</span></label>
                            <select id="director${directorNumber}NomineeIsDirector" name="director${directorNumber}NomineeIsDirector" class="w-full md:w-1/3 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" onchange="toggleNomineeDirectorWarning(${directorNumber})">
                                <option value="">Select...</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                        
                        <!-- Warning for nominee director -->
                        <div id="director${directorNumber}NomineeDirectorWarning" class="hidden mb-4">
                            <div class="bg-orange-50 border-l-4 border-orange-400 p-4">
                                <p class="text-sm text-orange-800">We do not encourage a director to hold shares for other stakeholders. Ensure that you enter into a shareholder's agreement.</p>
                            </div>
                        </div>
                        
                        <!-- Nominee individual details -->
                        <div id="director${directorNumber}NomineeDetails" class="hidden">
                            <h6 class="text-md font-medium text-gray-700 mb-3">Please provide details of the individual who will be holding the shares on behalf of the officeholder:</h6>
                            <p class="text-sm text-gray-600 mb-4">Please provide the following information:</p>
                            
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                <div>
                                    <label for="director${directorNumber}NomineeFirstName" class="block text-sm font-medium text-gray-700 mb-1">First name <span class="text-red-500">*</span></label>
                                    <input type="text" id="director${directorNumber}NomineeFirstName" name="director${directorNumber}NomineeFirstName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeMiddleName" class="block text-sm font-medium text-gray-700 mb-1">Middle name</label>
                                    <input type="text" id="director${directorNumber}NomineeMiddleName" name="director${directorNumber}NomineeMiddleName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeLastName" class="block text-sm font-medium text-gray-700 mb-1">Last name <span class="text-red-500">*</span></label>
                                    <input type="text" id="director${directorNumber}NomineeLastName" name="director${directorNumber}NomineeLastName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div class="md:col-span-2 lg:col-span-3">
                                    <label for="director${directorNumber}NomineeAddress" class="block text-sm font-medium text-gray-700 mb-1">Residential address <span class="text-red-500">*</span></label>
                                    <textarea id="director${directorNumber}NomineeAddress" name="director${directorNumber}NomineeAddress" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Enter full residential address"></textarea>
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeEmail" class="block text-sm font-medium text-gray-700 mb-1">Email <span class="text-red-500">*</span></label>
                                    <input type="email" id="director${directorNumber}NomineeEmail" name="director${directorNumber}NomineeEmail" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeTelephone" class="block text-sm font-medium text-gray-700 mb-1">Telephone <span class="text-red-500">*</span></label>
                                    <input type="tel" id="director${directorNumber}NomineeTelephone" name="director${directorNumber}NomineeTelephone" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeDateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Date of birth <span class="text-red-500">*</span></label>
                                    <input type="text" id="director${directorNumber}NomineeDateOfBirth" name="director${directorNumber}NomineeDateOfBirth" placeholder="DD/MM/YYYY" pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\\d{4}$" title="Please enter date in DD/MM/YYYY format" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeCityOfBirth" class="block text-sm font-medium text-gray-700 mb-1">City or suburb of birth <span class="text-red-500">*</span></label>
                                    <input type="text" id="director${directorNumber}NomineeCityOfBirth" name="director${directorNumber}NomineeCityOfBirth" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeCountryOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Country of birth <span class="text-red-500">*</span></label>
                                    <input type="text" id="director${directorNumber}NomineeCountryOfBirth" name="director${directorNumber}NomineeCountryOfBirth" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                                <div>
                                    <label for="director${directorNumber}NomineeTFN" class="block text-sm font-medium text-gray-700 mb-1">Personal Tax File Number (TFN) <span class="text-red-500">*</span></label>
                                    <input type="text" id="director${directorNumber}NomineeTFN" name="director${directorNumber}NomineeTFN" pattern="[0-9]{9}" maxlength="9" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                </div>
                            </div>
                            
                            <!-- Shareholder Questions for Nominee Individual -->
                            <div class="mt-6">
                                ${createShareholderQuestions(directorNumber, 'Nominee')}
                            </div>
                        </div>
                    </div>
                    
                    <!-- Company Fields -->
                    <div id="director${directorNumber}CompanyFields" class="hidden mt-4">
                        <h6 class="text-md font-medium text-gray-700 mb-3">Company Information</h6>
                        <p class="text-sm text-gray-600 mb-4">Please provide the following information:</p>
                        
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="md:col-span-2">
                                <label for="director${directorNumber}CompanyName" class="block text-sm font-medium text-gray-700 mb-1">Please provide the registered name of the legal entity that will hold the share: <span class="text-red-500">*</span></label>
                                <input type="text" id="director${directorNumber}CompanyName" name="director${directorNumber}CompanyName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            <div>
                                <label for="director${directorNumber}CompanyACN" class="block text-sm font-medium text-gray-700 mb-1">Please provide the Australian Company Number (ACN): <span class="text-red-500">*</span></label>
                                <input type="text" id="director${directorNumber}CompanyACN" name="director${directorNumber}CompanyACN" pattern="[0-9]{3}[\\s]?[0-9]{3}[\\s]?[0-9]{3}" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="123 456 789">
                            </div>
                            <div>
                                <label for="director${directorNumber}CompanyTFN" class="block text-sm font-medium text-gray-700 mb-1">The Tax File Number of the legal entity: <span class="text-red-500">*</span></label>
                                <input type="text" id="director${directorNumber}CompanyTFN" name="director${directorNumber}CompanyTFN" pattern="[0-9]{9}" maxlength="9" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                            <div class="md:col-span-2">
                                <label for="director${directorNumber}CompanyAddress" class="block text-sm font-medium text-gray-700 mb-1">Please provide the registered office address for the legal entity: <span class="text-red-500">*</span></label>
                                <textarea id="director${directorNumber}CompanyAddress" name="director${directorNumber}CompanyAddress" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Enter full registered office address"></textarea>
                            </div>
                        </div>
                        
                        <!-- Shareholder Questions for Company -->
                        <div id="director${directorNumber}CompanyShareholderQuestions" class="mt-6">
                            ${createShareholderQuestions(directorNumber, 'Company')}
                        </div>
                    </div>

                    <!-- Trust Fields -->
                    <div id="director${directorNumber}TrustFields" class="hidden mt-4">
                        <h6 class="text-md font-medium text-gray-700 mb-3">Trust Information</h6>
                        <p class="text-sm text-gray-600 mb-4">Please provide the following information:</p>
                        
                        <!-- Trustee Details -->
                        <div class="mb-6">
                            <h6 class="text-md font-medium text-gray-700 mb-3">Trustee Details</h6>
                            <div class="mb-3">
                                <label for="director${directorNumber}TrusteeType" class="block text-sm font-medium text-gray-700 mb-1">Is the Trustee an individual or corporate? <span class="text-red-500">*</span></label>
                                <select id="director${directorNumber}TrusteeType" name="director${directorNumber}TrusteeType" class="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" onchange="toggleTrustShareholderFields(${directorNumber})">>
                                    <option value="">Select...</option>
                                    <option value="individual">Individual</option>
                                    <option value="company">Company</option>
                                </select>
                            </div>
                            
                            <!-- Individual Trustee Fields -->
                            <div id="director${directorNumber}IndividualTrusteeFields" class="hidden">
                                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                    <div>
                                        <label for="director${directorNumber}TrusteeFirstName" class="block text-sm font-medium text-gray-700 mb-1">First name <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeFirstName" name="director${directorNumber}TrusteeFirstName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeMiddleName" class="block text-sm font-medium text-gray-700 mb-1">Middle name</label>
                                        <input type="text" id="director${directorNumber}TrusteeMiddleName" name="director${directorNumber}TrusteeMiddleName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeLastName" class="block text-sm font-medium text-gray-700 mb-1">Last name <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeLastName" name="director${directorNumber}TrusteeLastName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div class="md:col-span-2 lg:col-span-3">
                                        <label for="director${directorNumber}TrusteeAddress" class="block text-sm font-medium text-gray-700 mb-1">Residential address <span class="text-red-500">*</span></label>
                                        <textarea id="director${directorNumber}TrusteeAddress" name="director${directorNumber}TrusteeAddress" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Enter full residential address"></textarea>
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeEmail" class="block text-sm font-medium text-gray-700 mb-1">Email <span class="text-red-500">*</span></label>
                                        <input type="email" id="director${directorNumber}TrusteeEmail" name="director${directorNumber}TrusteeEmail" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeTelephone" class="block text-sm font-medium text-gray-700 mb-1">Telephone <span class="text-red-500">*</span></label>
                                        <input type="tel" id="director${directorNumber}TrusteeTelephone" name="director${directorNumber}TrusteeTelephone" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeDateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Date of birth <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeDateOfBirth" name="director${directorNumber}TrusteeDateOfBirth" placeholder="DD/MM/YYYY" pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\\d{4}$" title="Please enter date in DD/MM/YYYY format" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeCityOfBirth" class="block text-sm font-medium text-gray-700 mb-1">City or suburb of birth <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeCityOfBirth" name="director${directorNumber}TrusteeCityOfBirth" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeCountryOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Country of birth <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeCountryOfBirth" name="director${directorNumber}TrusteeCountryOfBirth" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeTFN" class="block text-sm font-medium text-gray-700 mb-1">Personal Tax File Number (TFN) <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeTFN" name="director${directorNumber}TrusteeTFN" pattern="[0-9]{9}" maxlength="9" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Corporate Trustee Fields -->
                            <div id="director${directorNumber}CorporateTrusteeFields" class="hidden">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div class="md:col-span-2">
                                        <label for="director${directorNumber}TrusteeCompanyName" class="block text-sm font-medium text-gray-700 mb-1">Please provide the registered name of the legal entity that will hold the share: <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeCompanyName" name="director${directorNumber}TrusteeCompanyName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                                    </div>
                                    <div>
                                        <label for="director${directorNumber}TrusteeCompanyACN" class="block text-sm font-medium text-gray-700 mb-1">Please provide the Australian Company Number (ACN): <span class="text-red-500">*</span></label>
                                        <input type="text" id="director${directorNumber}TrusteeCompanyACN" name="director${directorNumber}TrusteeCompanyACN" pattern="[0-9]{3}[\\s]?[0-9]{3}[\\s]?[0-9]{3}" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="123 456 789">
                                    </div>
                                    <div class="md:col-span-2">
                                        <label for="director${directorNumber}TrusteeCompanyAddress" class="block text-sm font-medium text-gray-700 mb-1">Please provide the registered office address for the legal entity: <span class="text-red-500">*</span></label>
                                        <textarea id="director${directorNumber}TrusteeCompanyAddress" name="director${directorNumber}TrusteeCompanyAddress" rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Enter full registered office address"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Trust Details -->
                        <div class="mb-4">
                            <h6 class="text-md font-medium text-gray-700 mb-3">Trust Details</h6>
                            <div>
                                <label for="director${directorNumber}TrustName" class="block text-sm font-medium text-gray-700 mb-1">What is the Trust Name? <span class="text-red-500">*</span></label>
                                <input type="text" id="director${directorNumber}TrustName" name="director${directorNumber}TrustName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                            </div>
                        </div>
                        
                        <!-- Shareholder Questions for Trust -->
                        <div class="mt-6">
                            ${createShareholderQuestions(directorNumber, 'Trust')}
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label for="director${directorNumber}Industry" class="block text-sm font-medium text-gray-700 mb-1">What industry will the new entity operate in? <span class="text-red-500">*</span></label>
                        <input type="text" id="director${directorNumber}Industry" name="director${directorNumber}Industry" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                    </div>
                    <div>
                        <label for="director${directorNumber}BusinessActivity" class="block text-sm font-medium text-gray-700 mb-1">What is your business activity? <span class="text-red-500">*</span></label>
                        <input type="text" id="director${directorNumber}BusinessActivity" name="director${directorNumber}BusinessActivity" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                    </div>
                </div>
            </div>
        </div>
    `;
}

// Toggle shareholder fields for each director
function toggleShareholderFields(directorNumber) {
    const isShareHolder = document.getElementById(`director${directorNumber}IsShareHolder`).value;
    const shareholderFields = document.getElementById(`director${directorNumber}ShareholderFields`);
    const nonShareholderFields = document.getElementById(`director${directorNumber}NonShareholderFields`);
    
    if (isShareHolder === 'yes') {
        shareholderFields.classList.remove('hidden');
        nonShareholderFields.classList.add('hidden');
    } else if (isShareHolder === 'no') {
        shareholderFields.classList.add('hidden');
        nonShareholderFields.classList.remove('hidden');
    } else {
        shareholderFields.classList.add('hidden');
        nonShareholderFields.classList.add('hidden');
    }
}

function toggleNomineeFields(directorNumber) {
    console.log('toggleNomineeFields called for director:', directorNumber);
    const shareholdingType = document.getElementById(`director${directorNumber}ShareHolderType`).value;
    console.log('shareholdingType:', shareholdingType);
    
    const nomineeFields = document.getElementById(`director${directorNumber}NomineeFields`);
    const companyFields = document.getElementById(`director${directorNumber}CompanyFields`);
    const trustFields = document.getElementById(`director${directorNumber}TrustFields`);
    
    console.log('nomineeFields element:', nomineeFields);
    console.log('companyFields element:', companyFields);
    console.log('trustFields element:', trustFields);
    
    // Hide all fields first
    if (nomineeFields) nomineeFields.classList.add('hidden');
    if (companyFields) companyFields.classList.add('hidden');
    if (trustFields) trustFields.classList.add('hidden');
    
    if (shareholdingType === 'nominee-individual' && nomineeFields) {
        console.log('Showing nominee fields');
        nomineeFields.classList.remove('hidden');
    } else if (shareholdingType === 'company' && companyFields) {
        console.log('Showing company fields');
        companyFields.classList.remove('hidden');
    } else if (shareholdingType === 'trust' && trustFields) {
        console.log('Showing trust fields');
        trustFields.classList.remove('hidden');
    }
    
    // Hide sub-fields when hiding nominee fields
    if (shareholdingType !== 'nominee-individual') {
        const warningField = document.getElementById(`director${directorNumber}NomineeDirectorWarning`);
        const detailsField = document.getElementById(`director${directorNumber}NomineeDetails`);
        if (warningField) warningField.classList.add('hidden');
        if (detailsField) detailsField.classList.add('hidden');
    }
}

function toggleShareholdingFields(directorNumber) {
    const shareholdingType = document.getElementById(`director${directorNumber}ShareHolderType`).value;
    const nomineeFields = document.getElementById(`director${directorNumber}NomineeFields`);
    const companyFields = document.getElementById(`director${directorNumber}CompanyFields`);
    const trustFields = document.getElementById(`director${directorNumber}TrustFields`);
    
    // Hide all fields first
    if (nomineeFields) nomineeFields.classList.add('hidden');
    if (companyFields) companyFields.classList.add('hidden');
    if (trustFields) trustFields.classList.add('hidden');
    
    if (shareholdingType === 'nominee-individual' && nomineeFields) {
        nomineeFields.classList.remove('hidden');
    } else if (shareholdingType === 'company' && companyFields) {
        companyFields.classList.remove('hidden');
    } else if (shareholdingType === 'trust' && trustFields) {
        trustFields.classList.remove('hidden');
    }
}

function toggleNomineeDirectorWarning(directorNumber) {
    const isDirector = document.getElementById(`director${directorNumber}NomineeIsDirector`).value;
    const warning = document.getElementById(`director${directorNumber}NomineeDirectorWarning`);
    const details = document.getElementById(`director${directorNumber}NomineeDetails`);
    
    if (isDirector === 'yes') {
        if (warning) warning.classList.remove('hidden');
        if (details) details.classList.add('hidden');
    } else if (isDirector === 'no') {
        if (warning) warning.classList.add('hidden');
        if (details) details.classList.remove('hidden');
    } else {
        if (warning) warning.classList.add('hidden');
        if (details) details.classList.add('hidden');
    }
}

// Toggle trustee fields for trust shareholding
function toggleTrustShareholderFields(directorNumber) {
    const trusteeType = document.getElementById(`director${directorNumber}TrusteeType`).value;
    const individualFields = document.getElementById(`director${directorNumber}IndividualTrusteeFields`);
    const corporateFields = document.getElementById(`director${directorNumber}CorporateTrusteeFields`);
    
    // Hide all fields first
    if (individualFields) individualFields.classList.add('hidden');
    if (corporateFields) corporateFields.classList.add('hidden');
    
    if (trusteeType === 'individual' && individualFields) {
        individualFields.classList.remove('hidden');
    } else if (trusteeType === 'company' && corporateFields) {
        corporateFields.classList.remove('hidden');
    }
}

// Set required attributes for individual fields
function setIndividualFieldsRequired(required) {
    const fields = ['individualFirstName', 'individualLastName', 'individualEmail', 'individualTelephone', 'individualDateOfBirth', 'individualCityOfBirth', 'individualCountryOfBirth', 'individualTFN', 'individualDIN'];
    fields.forEach(field => {
        const element = document.getElementById(field);
        if (element) {
            if (required) {
                element.setAttribute('required', '');
            } else {
                element.removeAttribute('required');
            }
        }
    });
}

// Set required attributes for corporate fields
function setCorporateFieldsRequired(required) {
    const isExistingField = document.getElementById('isExistingCompany');
    if (isExistingField) {
        if (required) {
            isExistingField.setAttribute('required', '');
        } else {
            isExistingField.removeAttribute('required');
        }
    }
}

// Set required attributes for existing company fields
function setExistingCompanyFieldsRequired(required) {
    const fields = ['existingCompanyACN', 'existingCompanyName'];
    fields.forEach(field => {
        const element = document.getElementById(field);
        if (element) {
            if (required) {
                element.setAttribute('required', '');
            } else {
                element.removeAttribute('required');
            }
        }
    });
}

// Set required attributes for new company fields
function setNewCompanyFieldsRequired(required) {
    const fields = ['proposedCompanyName', 'numberOfDirectors'];
    fields.forEach(field => {
        const element = document.getElementById(field);
        if (element) {
            if (required) {
                element.setAttribute('required', '');
            } else {
                element.removeAttribute('required');
            }
        }
    });
}

// Make all functions available globally for onclick handlers
window.toggleTrusteeFields = toggleTrusteeFields;
window.toggleCompanyFields = toggleCompanyFields;
window.generateDirectorFields = generateDirectorFields;
window.createDirectorFields = createDirectorFields;
window.createShareholderQuestions = createShareholderQuestions;
window.toggleShareholderFields = toggleShareholderFields;
window.toggleNomineeFields = toggleNomineeFields;
window.toggleShareholdingFields = toggleShareholdingFields;
window.toggleNomineeDirectorWarning = toggleNomineeDirectorWarning;
window.toggleTrustShareholderFields = toggleTrustShareholderFields;
window.setIndividualFieldsRequired = setIndividualFieldsRequired;
window.setCorporateFieldsRequired = setCorporateFieldsRequired;
window.setExistingCompanyFieldsRequired = setExistingCompanyFieldsRequired;
window.setNewCompanyFieldsRequired = setNewCompanyFieldsRequired;
window.changeStep = changeStep;
window.handleNextStep = handleNextStep;
window.validateCurrentStep = validateCurrentStep;
window.isFieldVisible = isFieldVisible;
window.updateProgress = updateProgress;
window.updateNavigationButtons = updateNavigationButtons;
window.populateReviewContent = populateReviewContent;
window.initializeInfoBubbles = initializeInfoBubbles;

// Business Structure Functions
function toggleTrustTypeFields() {
    const trustType = document.getElementById('trustType');
    const discretionarySection = document.getElementById('discretionaryTrustSection');
    const unitTrustSection = document.getElementById('unitTrustSection');
    const otherTrustSection = document.getElementById('otherTrustSection');
    
    if (!trustType) return;
    
    // Hide all sections initially
    discretionarySection.classList.add('hidden');
    unitTrustSection.classList.add('hidden');
    otherTrustSection.classList.add('hidden');
    
    // Clear all dynamic content
    clearDynamicFields();
    
    const selectedValue = trustType.value;
    
    if (selectedValue === 'Discretionary Trust') {
        discretionarySection.classList.remove('hidden');
    } else if (selectedValue === 'Unit Trusts') {
        unitTrustSection.classList.remove('hidden');
    } else if (selectedValue !== '') {
        // Show beneficiaries section for other trust types
        otherTrustSection.classList.remove('hidden');
    }
}

function clearDynamicFields() {
    const containers = [
        'discretionaryBeneficiariesContainer',
        'unitHoldersContainer', 
        'otherBeneficiariesContainer'
    ];
    
    containers.forEach(containerId => {
        const container = document.getElementById(containerId);
        if (container) {
            container.innerHTML = '';
        }
    });
    
    // Reset dropdowns
    const selects = ['discretionaryBeneficiaries', 'unitHolders', 'otherBeneficiaries'];
    selects.forEach(selectId => {
        const select = document.getElementById(selectId);
        if (select) {
            select.value = '';
        }
    });
}

function generateDiscretionaryBeneficiaryFields() {
    const count = document.getElementById('discretionaryBeneficiaries').value;
    const container = document.getElementById('discretionaryBeneficiariesContainer');
    
    if (!count || !container) return;
    
    container.innerHTML = '';
    
    for (let i = 1; i <= parseInt(count); i++) {
        const beneficiaryDiv = document.createElement('div');
        beneficiaryDiv.className = 'bg-gray-50 p-4 rounded-lg border';
        beneficiaryDiv.innerHTML = generateBeneficiaryHTML(i, 'discretionary');
        container.appendChild(beneficiaryDiv);
    }
}

function generateUnitHolderFields() {
    const count = document.getElementById('unitHolders').value;
    const container = document.getElementById('unitHoldersContainer');
    
    if (!count || !container) return;
    
    container.innerHTML = '';
    
    for (let i = 1; i <= parseInt(count); i++) {
        const unitHolderDiv = document.createElement('div');
        unitHolderDiv.className = 'bg-gray-50 p-4 rounded-lg border';
        unitHolderDiv.innerHTML = generateUnitHolderHTML(i);
        container.appendChild(unitHolderDiv);
    }
}

function generateOtherBeneficiaryFields() {
    const count = document.getElementById('otherBeneficiaries').value;
    const container = document.getElementById('otherBeneficiariesContainer');
    
    if (!count || !container) return;
    
    container.innerHTML = '';
    
    for (let i = 1; i <= parseInt(count); i++) {
        const beneficiaryDiv = document.createElement('div');
        beneficiaryDiv.className = 'bg-gray-50 p-4 rounded-lg border';
        beneficiaryDiv.innerHTML = generateBeneficiaryHTML(i, 'other');
        container.appendChild(beneficiaryDiv);
    }
}

function generateBeneficiaryHTML(index, type) {
    const prefix = type === 'discretionary' ? 'discretionaryBeneficiary' : 'otherBeneficiary';
    return `
        <h4 class="text-md font-semibold mb-3 text-gray-800">Beneficiary ${index}</h4>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
                <label for="${prefix}${index}FirstName" class="block text-sm font-medium text-gray-700 mb-1">First name <span class="text-red-500">*</span></label>
                <input type="text" id="${prefix}${index}FirstName" name="${prefix}${index}FirstName" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}MiddleName" class="block text-sm font-medium text-gray-700 mb-1">Middle name</label>
                <input type="text" id="${prefix}${index}MiddleName" name="${prefix}${index}MiddleName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}LastName" class="block text-sm font-medium text-gray-700 mb-1">Last name <span class="text-red-500">*</span></label>
                <input type="text" id="${prefix}${index}LastName" name="${prefix}${index}LastName" required class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}Email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" id="${prefix}${index}Email" name="${prefix}${index}Email" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}Telephone" class="block text-sm font-medium text-gray-700 mb-1">Telephone</label>
                <input type="tel" id="${prefix}${index}Telephone" name="${prefix}${index}Telephone" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}DateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Date of birth</label>
                <input type="text" id="${prefix}${index}DateOfBirth" name="${prefix}${index}DateOfBirth" placeholder="DD/MM/YYYY" pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\\d{4}$" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}Relationship" class="block text-sm font-medium text-gray-700 mb-1">Relationship</label>
                <input type="text" id="${prefix}${index}Relationship" name="${prefix}${index}Relationship" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div class="md:col-span-2 lg:col-span-3">
                <label for="${prefix}${index}Address" class="block text-sm font-medium text-gray-700 mb-1">Residential Address</label>
                <input type="text" id="${prefix}${index}Address" name="${prefix}${index}Address" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Street address">
            </div>
            <div>
                <label for="${prefix}${index}Suburb" class="block text-sm font-medium text-gray-700 mb-1">Suburb</label>
                <input type="text" id="${prefix}${index}Suburb" name="${prefix}${index}Suburb" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}State" class="block text-sm font-medium text-gray-700 mb-1">State</label>
                <select id="${prefix}${index}State" name="${prefix}${index}State" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                    <option value="">Select...</option>
                    <option value="NSW">NSW</option>
                    <option value="VIC">VIC</option>
                    <option value="QLD">QLD</option>
                    <option value="SA">SA</option>
                    <option value="WA">WA</option>
                    <option value="TAS">TAS</option>
                    <option value="NT">NT</option>
                    <option value="ACT">ACT</option>
                </select>
            </div>
            <div>
                <label for="${prefix}${index}Postcode" class="block text-sm font-medium text-gray-700 mb-1">Postcode</label>
                <input type="text" id="${prefix}${index}Postcode" name="${prefix}${index}Postcode" maxlength="4" pattern="[0-9]{4}" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}${index}TFN" class="block text-sm font-medium text-gray-700 mb-1">Tax File Number</label>
                <input type="text" id="${prefix}${index}TFN" name="${prefix}${index}TFN" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" maxlength="9" pattern="[0-9]{9}">
            </div>
            <div>
                <label for="${prefix}${index}PercentageEntitlement" class="block text-sm font-medium text-gray-700 mb-1">Percentage Entitlement (%)</label>
                <input type="number" id="${prefix}${index}PercentageEntitlement" name="${prefix}${index}PercentageEntitlement" min="0" max="100" step="0.01" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
        </div>
    `;
}

function generateUnitHolderHTML(index) {
    const prefix = `unitHolder${index}`;
    return `
        <h4 class="text-md font-semibold mb-3 text-gray-800">Unit Holder ${index}</h4>
        <div class="mb-4">
            <label for="${prefix}HolderType" class="block text-sm font-medium text-gray-700 mb-2">Unit holder type <span class="text-red-500">*</span></label>
            <select id="${prefix}HolderType" name="${prefix}HolderType" required class="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" onchange="toggleUnitHolderFields(${index})">
                <option value="">Select type...</option>
                <option value="individual">Individual</option>
                <option value="company">Company</option>
            </select>
        </div>

        <!-- Individual Unit Holder Fields -->
        <div id="individualUnitHolder${index}" class="hidden">
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                    <label for="${prefix}FirstName" class="block text-sm font-medium text-gray-700 mb-1">First name</label>
                    <input type="text" id="${prefix}FirstName" name="${prefix}FirstName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}MiddleName" class="block text-sm font-medium text-gray-700 mb-1">Middle name</label>
                    <input type="text" id="${prefix}MiddleName" name="${prefix}MiddleName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}LastName" class="block text-sm font-medium text-gray-700 mb-1">Last name</label>
                    <input type="text" id="${prefix}LastName" name="${prefix}LastName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}Email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input type="email" id="${prefix}Email" name="${prefix}Email" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}Telephone" class="block text-sm font-medium text-gray-700 mb-1">Telephone</label>
                    <input type="tel" id="${prefix}Telephone" name="${prefix}Telephone" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}DateOfBirth" class="block text-sm font-medium text-gray-700 mb-1">Date of birth</label>
                    <input type="text" id="${prefix}DateOfBirth" name="${prefix}DateOfBirth" placeholder="DD/MM/YYYY" pattern="^(0[1-9]|[12][0-9]|3[01])/(0[1-9]|1[0-2])/\\d{4}$" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div class="md:col-span-2 lg:col-span-3">
                    <label for="${prefix}Address" class="block text-sm font-medium text-gray-700 mb-1">Residential Address</label>
                    <input type="text" id="${prefix}Address" name="${prefix}Address" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" placeholder="Street address">
                </div>
                <div>
                    <label for="${prefix}Suburb" class="block text-sm font-medium text-gray-700 mb-1">Suburb</label>
                    <input type="text" id="${prefix}Suburb" name="${prefix}Suburb" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}State" class="block text-sm font-medium text-gray-700 mb-1">State</label>
                    <select id="${prefix}State" name="${prefix}State" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                        <option value="">Select...</option>
                        <option value="NSW">NSW</option>
                        <option value="VIC">VIC</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="WA">WA</option>
                        <option value="TAS">TAS</option>
                        <option value="NT">NT</option>
                        <option value="ACT">ACT</option>
                    </select>
                </div>
                <div>
                    <label for="${prefix}Postcode" class="block text-sm font-medium text-gray-700 mb-1">Postcode</label>
                    <input type="text" id="${prefix}Postcode" name="${prefix}Postcode" maxlength="4" pattern="[0-9]{4}" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}TFN" class="block text-sm font-medium text-gray-700 mb-1">Tax File Number</label>
                    <input type="text" id="${prefix}TFN" name="${prefix}TFN" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" maxlength="9" pattern="[0-9]{9}">
                </div>
            </div>
        </div>

        <!-- Company Unit Holder Fields -->
        <div id="companyUnitHolder${index}" class="hidden">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="${prefix}CompanyName" class="block text-sm font-medium text-gray-700 mb-1">Company name</label>
                    <input type="text" id="${prefix}CompanyName" name="${prefix}CompanyName" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
                <div>
                    <label for="${prefix}ABN" class="block text-sm font-medium text-gray-700 mb-1">ABN</label>
                    <input type="text" id="${prefix}ABN" name="${prefix}ABN" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400" maxlength="11" pattern="[0-9]{11}">
                </div>
                <div class="md:col-span-2">
                    <label for="${prefix}CompanyAddress" class="block text-sm font-medium text-gray-700 mb-1">Company address</label>
                    <input type="text" id="${prefix}CompanyAddress" name="${prefix}CompanyAddress" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
                </div>
            </div>
        </div>

        <div class="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
                <label for="${prefix}NumberOfUnits" class="block text-sm font-medium text-gray-700 mb-1">Number of units</label>
                <input type="number" id="${prefix}NumberOfUnits" name="${prefix}NumberOfUnits" min="1" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}ValuePerUnit" class="block text-sm font-medium text-gray-700 mb-1">Value per unit ($)</label>
                <input type="number" id="${prefix}ValuePerUnit" name="${prefix}ValuePerUnit" min="0" step="0.01" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
            <div>
                <label for="${prefix}TotalInvestment" class="block text-sm font-medium text-gray-700 mb-1">Total investment ($)</label>
                <input type="number" id="${prefix}TotalInvestment" name="${prefix}TotalInvestment" min="0" step="0.01" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gold-400">
            </div>
        </div>
    `;
}

function toggleUnitHolderFields(index) {
    const typeSelect = document.getElementById(`unitHolderType${index}`);
    const individualSection = document.getElementById(`individualUnitHolder${index}`);
    const companySection = document.getElementById(`companyUnitHolder${index}`);
    
    if (!typeSelect || !individualSection || !companySection) return;
    
    const selectedValue = typeSelect.value;
    
    if (selectedValue === 'individual') {
        individualSection.classList.remove('hidden');
        companySection.classList.add('hidden');
        
        // Make individual fields required
        const individualFields = individualSection.querySelectorAll('input');
        individualFields.forEach(field => field.required = true);
        
        // Make company fields not required
        const companyFields = companySection.querySelectorAll('input');
        companyFields.forEach(field => field.required = false);
    } else if (selectedValue === 'company') {
        individualSection.classList.add('hidden');
        companySection.classList.remove('hidden');
        
        // Make company fields required
        const companyFields = companySection.querySelectorAll('input');
        companyFields.forEach(field => field.required = true);
        
        // Make individual fields not required
        const individualFields = individualSection.querySelectorAll('input');
        individualFields.forEach(field => field.required = false);
    } else {
        individualSection.classList.add('hidden');
        companySection.classList.add('hidden');
        
        // Make all fields not required
        const allFields = document.querySelectorAll(`#individualUnitHolder${index} input, #companyUnitHolder${index} input`);
        allFields.forEach(field => field.required = false);
    }
}

// Make business structure functions available globally
window.toggleTrustTypeFields = toggleTrustTypeFields;
window.clearDynamicFields = clearDynamicFields;
window.generateDiscretionaryBeneficiaryFields = generateDiscretionaryBeneficiaryFields;
window.generateUnitHolderFields = generateUnitHolderFields;
window.generateOtherBeneficiaryFields = generateOtherBeneficiaryFields;
window.generateBeneficiaryHTML = generateBeneficiaryHTML;
window.generateUnitHolderHTML = generateUnitHolderHTML;
window.toggleUnitHolderFields = toggleUnitHolderFields;

// Trust Signature Canvas functionality
let trustSignatureCanvas;
let trustSignatureCtx;
let trustSignatureDrawing = false;

function initializeTrustSignatureCanvas() {
    trustSignatureCanvas = document.getElementById('trustSignatureCanvas');
    if (!trustSignatureCanvas) return;
    
    trustSignatureCtx = trustSignatureCanvas.getContext('2d');
    
    // Set canvas background to white
    trustSignatureCtx.fillStyle = 'white';
    trustSignatureCtx.fillRect(0, 0, trustSignatureCanvas.width, trustSignatureCanvas.height);
    
    // Set drawing properties
    trustSignatureCtx.strokeStyle = '#000000';
    trustSignatureCtx.lineWidth = 2;
    trustSignatureCtx.lineCap = 'round';
    trustSignatureCtx.lineJoin = 'round';
    
    // Mouse events
    trustSignatureCanvas.addEventListener('mousedown', startTrustSignature);
    trustSignatureCanvas.addEventListener('mousemove', drawTrustSignature);
    trustSignatureCanvas.addEventListener('mouseup', endTrustSignature);
    trustSignatureCanvas.addEventListener('mouseout', endTrustSignature);
    
    // Touch events for mobile
    trustSignatureCanvas.addEventListener('touchstart', function(e) {
        e.preventDefault();
        const touch = e.touches[0];
        const rect = trustSignatureCanvas.getBoundingClientRect();
        const scaleX = trustSignatureCanvas.width / rect.width;
        const scaleY = trustSignatureCanvas.height / rect.height;
        
        trustSignatureDrawing = true;
        trustSignatureCtx.beginPath();
        trustSignatureCtx.moveTo((touch.clientX - rect.left) * scaleX, (touch.clientY - rect.top) * scaleY);
    });
    
    trustSignatureCanvas.addEventListener('touchmove', function(e) {
        e.preventDefault();
        if (!trustSignatureDrawing) return;
        
        const touch = e.touches[0];
        const rect = trustSignatureCanvas.getBoundingClientRect();
        const scaleX = trustSignatureCanvas.width / rect.width;
        const scaleY = trustSignatureCanvas.height / rect.height;
        
        trustSignatureCtx.lineTo((touch.clientX - rect.left) * scaleX, (touch.clientY - rect.top) * scaleY);
        trustSignatureCtx.stroke();
    });
    
    trustSignatureCanvas.addEventListener('touchend', function(e) {
        e.preventDefault();
        trustSignatureDrawing = false;
        saveTrustSignature();
    });
    
    // Clear button
    const clearBtn = document.getElementById('clearTrustSignature');
    if (clearBtn) {
        clearBtn.addEventListener('click', clearTrustSignature);
    }
}

function startTrustSignature(e) {
    trustSignatureDrawing = true;
    const rect = trustSignatureCanvas.getBoundingClientRect();
    const scaleX = trustSignatureCanvas.width / rect.width;
    const scaleY = trustSignatureCanvas.height / rect.height;
    
    trustSignatureCtx.beginPath();
    trustSignatureCtx.moveTo((e.clientX - rect.left) * scaleX, (e.clientY - rect.top) * scaleY);
}

function drawTrustSignature(e) {
    if (!trustSignatureDrawing) return;
    
    const rect = trustSignatureCanvas.getBoundingClientRect();
    const scaleX = trustSignatureCanvas.width / rect.width;
    const scaleY = trustSignatureCanvas.height / rect.height;
    
    trustSignatureCtx.lineTo((e.clientX - rect.left) * scaleX, (e.clientY - rect.top) * scaleY);
    trustSignatureCtx.stroke();
}

function endTrustSignature() {
    if (!trustSignatureDrawing) return;
    trustSignatureDrawing = false;
    saveTrustSignature();
}

function saveTrustSignature() {
    const dataURL = trustSignatureCanvas.toDataURL('image/png');
    document.getElementById('trustSignatureData').value = dataURL;
}

function clearTrustSignature() {
    trustSignatureCtx.fillStyle = 'white';
    trustSignatureCtx.fillRect(0, 0, trustSignatureCanvas.width, trustSignatureCanvas.height);
    document.getElementById('trustSignatureData').value = '';
}

// Initialize signature canvas when Step 4 becomes visible (moved to main initialization)

// Make signature functions available globally
window.initializeTrustSignatureCanvas = initializeTrustSignatureCanvas;
window.clearTrustSignature = clearTrustSignature;
